
// Mutation Types Const

// App
export const APP_INIT_LOADING = 'APP_INIT_LOADING'
export const APP_INIT_SUCCESS = 'APP_INIT_SUCCESS'
export const APP_INIT_FAIL = 'APP_INIT_FAIL'
export const APP_TOGGLE_MENU = 'APP_TOGGLE_MENU'
export const APP_TOGGLE_SEARCH = 'APP_TOGGLE_SEARCH'
export const APP_INTERNAL_MENU = 'APP_INTERNAL_MENU'
export const APP_LOAD_THEME = 'APP_LOAD_THEME'
export const APP_LOGIN_MENU = 'APP_LOGIN_MENU'

// Token
export const USER_TOKEN_ADD = 'USER_TOKEN_ADD'
export const USER_TOKEN_REMOVE = 'USER_TOKEN_REMOVE'
export const USER_TOKEN_DETAILS_UPDATE = 'USER_TOKEN_DETAILS_UPDATE'

// Widgets
export const WIDGET_INIT_LOADING = 'WIDGET_INIT_LOADING'
export const WIDGET_INIT_SUCCESS = 'WIDGET_INIT_SUCCESS'
export const WIDGET_INIT_FAIL = 'WIDGET_INIT_FAIL'
export const WIDGET_ADD = 'WIDGET_ADD'
export const WIDGET_REMOVE = 'WIDGET_REMOVE'
export const WIDGET_ADJUST = 'WIDGET_ADJUST'
export const QUICKLAUNCH_INIT_LOADING = 'QUICKLAUNCH_INIT_LOADING'
export const QUICKLAUNCH_INIT_SUCCESS = 'QUICKLAUNCH_INIT_SUCCESS'
export const QUICKLAUNCH_INIT_FAIL = 'QUICKLAUNCH_INIT_FAIL'
export const QUICKLAUNCH_ADD = 'QUICKLAUNCH_ADD'
export const QUICKLAUNCH_REMOVE = 'QUICKLAUNCH_REMOVE'
export const TODO_INIT_LOADING = 'TODO_INIT_LOADING'
export const TODO_INIT_SUCCESS = 'TODO_INIT_SUCCESS'
export const TODO_INIT_FAIL = 'TODO_INIT_FAIL'
export const TODO_ADD = 'TODO_ADD'
export const TODO_REMOVE = 'TODO_REMOVE'
export const TODO_UPDATE = 'TODO_UPDATE'
export const TODO_UNDO = 'TODO_UNDO'
export const TODO_EDIT = 'TODO_EDIT'
export const TODO_COMPLETED_INIT_LOADING = 'TODO_COMPLETED_INIT_LOADING'
export const TODO_COMPLETED_INIT_SUCCESS = 'TODO_COMPLETED_INIT_SUCCESS'
export const TODO_COMPLETED_INIT_FAIL = 'TODO_COMPLETED_INIT_FAIL'
export const TODO_COMPLETED_UPDATE = 'TODO_COMPLETED_UPDATE'
export const TODO_COMPLETED_LOADMORE_LOADING = 'TODO_COMPLETED_LOADMORE_LOADING'
export const TODO_COMPLETED_LOADMORE_SUCCESS = 'TODO_COMPLETED_LOADMORE_SUCCESS'
export const TODO_COMPLETED_LOADMORE_FAIL = 'TODO_COMPLETED_LOADMORE_FAIL'
export const DEBUG_INIT_LOADING = 'DEBUG_INIT_LOADING'
export const DEBUG_INIT_SUCCESS = 'DEBUG_INIT_SUCCESS'
export const DEBUG_INIT_FAIL = 'DEBUG_INIT_FAIL'
export const MYSR_INIT_LOADING = 'MYSR_INIT_LOADING'
export const MYSR_INIT_SUCCESS = 'MYSR_INIT_SUCCESS'
export const MYSR_INIT_FAIL = 'MYSR_INIT_FAIL'
export const TOTALSR_INIT_LOADING = 'TOTALSR_INIT_LOADING'
export const TOTALSR_INIT_SUCCESS = 'TOTALSR_INIT_SUCCESS'
export const TOTALSR_INIT_FAIL = 'TOTALSR_INIT_FAIL'
export const USERSONLINE_INIT_LOADING = 'USERSONLINE_INIT_LOADING'
export const USERSONLINE_INIT_SUCCESS = 'USERSONLINE_INIT_SUCCESS'
export const USERSONLINE_INIT_FAIL = 'USERSONLINE_INIT_FAIL'
export const TOTALQI_INIT_LOADING = 'TOTALQI_INIT_LOADING'
export const TOTALQI_INIT_SUCCESS = 'TOTALQI_INIT_SUCCESS'
export const TOTALQI_INIT_FAIL = 'TOTALQI_INIT_FAIL'
export const MYQI_INIT_LOADING = 'MYQI_INIT_LOADING'
export const MYQI_INIT_SUCCESS = 'MYQI_INIT_SUCCESS'
export const MYQI_INIT_FAIL = 'MYQI_INIT_FAIL'
export const MYIP_INIT_LOADING = 'MYIP_INIT_LOADING'
export const MYIP_INIT_SUCCESS = 'MYIP_INIT_SUCCESS'
export const MYIP_INIT_FAIL = 'MYIP_INIT_FAIL'
export const TOTALIP_INIT_LOADING = 'TOTALIP_INIT_LOADING'
export const TOTALIP_INIT_SUCCESS = 'TOTALIP_INIT_SUCCESS'
export const TOTALIP_INIT_FAIL = 'TOTALIP_INIT_FAIL'
export const PENDMTR_INIT_LOADING = 'PENDMTR_INIT_LOADING'
export const PENDMTR_INIT_SUCCESS = 'PENDMTR_INIT_SUCCESS'
export const PENDMTR_INIT_FAIL = 'PENDMTR_INIT_FAIL'
export const REVENUECHART_INIT_LOADING = 'REVENUECHART_INIT_LOADING'
export const REVENUECHART_INIT_SUCCESS = 'REVENUECHART_INIT_SUCCESS'
export const REVENUECHART_INIT_FAIL = 'REVENUECHART_INIT_FAIL'
export const INFORCECHART_INIT_LOADING = 'INFORCECHART_INIT_LOADING'
export const INFORCECHART_INIT_SUCCESS = 'INFORCECHART_INIT_SUCCESS'
export const INFORCECHART_INIT_FAIL = 'INFORCECHART_INIT_FAIL'
export const CONVERSIONCHART_INIT_LOADING = 'CONVERSIONCHART_INIT_LOADING'
export const CONVERSIONCHART_INIT_SUCCESS = 'CONVERSIONCHART_INIT_SUCCESS'
export const CONVERSIONCHART_INIT_FAIL = 'CONVERSIONCHART_INIT_FAIL'
export const MYREVENUECHART_INIT_LOADING = 'MYREVENUECHART_INIT_LOADING'
export const MYREVENUECHART_INIT_SUCCESS = 'MYREVENUECHART_INIT_SUCCESS'
export const MYREVENUECHART_INIT_FAIL = 'MYREVENUECHART_INIT_FAIL'
export const MYINFORCECHART_INIT_LOADING = 'MYINFORCECHART_INIT_LOADING'
export const MYINFORCECHART_INIT_SUCCESS = 'MYINFORCECHART_INIT_SUCCESS'
export const MYINFORCECHART_INIT_FAIL = 'MYINFORCECHART_INIT_FAIL'
export const MYCONVERSIONCHART_INIT_LOADING = 'MYCONVERSIONCHART_INIT_LOADING'
export const MYCONVERSIONCHART_INIT_SUCCESS = 'MYCONVERSIONCHART_INIT_SUCCESS'
export const MYCONVERSIONCHART_INIT_FAIL = 'MYCONVERSIONCHART_INIT_FAIL'

export const SMSBALANCE_INIT_LOADING = 'SMSBALANCE_INIT_LOADING'
export const SMSBALANCE_INIT_SUCCESS = 'SMSBALANCE_INIT_SUCCESS'
export const SMSBALANCE_INIT_FAIL = 'SMSBALANCE_INIT_FAIL'

// Search
export const SEARCH_OPEN = 'SEARCH_OPEN'
export const SEARCH_CLOSE = 'SEARCH_CLOSE'
export const SEARCH_CATEGORY_SELECT = 'SEARCH_CATEGORY_SELECT'

// User
export const USER_PROFILE_LOADING = 'USER_PROFILE_LOADING'
export const USER_PROFILE_SUCCESS = 'USER_PROFILE_SUCCESS'
export const USER_PROFILE_FAIL = 'USER_PROFILE_FAIL'
export const USER_PASSWORD_SUCCESS = 'USER_PASSWORD_SUCCESS'
export const USER_SESSION_EXPIRED = 'USER_SESSION_EXPIRED'
export const USER_NOTIFICATION_LOADING = 'USER_NOTIFICATION_LOADING'
export const USER_NOTIFICATION_SUCCESS = 'USER_NOTIFICATION_SUCCESS'
export const USER_NOTIFICATION_FAIL = 'USER_NOTIFICATION_FAIL'
export const USER_NOTIFICATION_UNFLAGNEW = 'USER_NOTIFICATION_UNFLAGNEW'
export const USER_NOTIFICATION_FLAGREAD = 'USER_NOTIFICATION_FLAGREAD'
export const USER_NOTIFICATION_FLAGALLREAD = 'USER_NOTIFICATION_FLAGALLREAD'
export const USER_NOTIFICATION_LOADMORE_LOADING = 'USER_NOTIFICATION_LOADMORE_LOADING'
export const USER_NOTIFICATION_LOADMORE_SUCCESS = 'USER_NOTIFICATION_LOADMORE_SUCCESS'
export const USER_NOTIFICATION_LOADMORE_FAIL = 'USER_NOTIFICATION_LOADMORE_FAIL'
export const USER_RPT_PROCESS_CLOSE = 'USER_RPT_PROCESS_CLOSE'
export const USER_RPT_PROCESS = 'USER_RPT_PROCESS'
export const USER_RPT_PROCESS_REMOVE = 'USER_RPT_PROCESS_REMOVE'
export const USER_RPT_PROCESS_DOWNLOADSTATUS = 'USER_RPT_PROCESS_DOWNLOADSTATUS'
export const USER_RPT_PROCESS_STATE = 'USER_RPT_PROCESS_STATE'
export const USER_NOTIFICATION_GET_COUNT = 'USER_NOTIFICATION_GET_COUNT'
export const USER_NOTIFICATION_RPT_CHG = 'USER_NOTIFICATION_RPT_CHG'
export const USER_NOTIFICATION_BCH_CHG = 'USER_NOTIFICATION_BCH_CHG'
export const USER_BCH_PROCESS = 'USER_BCH_PROCESS'
export const USER_RPT_GET_COUNT = 'USER_RPT_GET_COUNT'
export const USER_MSG_GET_COUNT = 'USER_MSG_GET_COUNT'
export const USER_BCH_GET_COUNT = 'USER_BCH_GET_COUNT'

// Claims
// export const CLAIMS_INIT_LOADING = 'CLAIMS_INIT_LOADING'
// export const CLAIMS_INIT_SUCCESS = 'CLAIMS_INIT_SUCCESS'
// export const CLAIMS_INIT_FAIL = 'CLAIMS_INIT_FAIL'
// export const INITIAL_CLAIM_STATE = 'INITIAL_CLAIM_STATE'
export const INIT_CLAIM_POLICY = 'INIT_CLAIM_POLICY'
// export const CLAIMS_CLAIMDETAIL_RESET = 'CLAIMS_CLAIMDETAIL_RESET'
// export const CLAIMS_CLAIMDETAIL_LIST = 'CLAIMS_CLAIMDETAIL_LIST'
export const CLAIMS_CLAIMDETAIL_EDITSTATUS = 'CLAIMS_CLAIMDETAIL_EDITSTATUS'
// export const CLAIMS_CLAIMDETAIL_INIT_LOADING = 'CLAIMS_CLAIMDETAIL_INIT_LOADING'
// export const CLAIMS_CLAIMDETAIL_INIT_SUCCESS = 'CLAIMS_CLAIMDETAIL_INIT_SUCCESS'
// export const CLAIMS_CLAIMDETAIL_INIT_FAIL = 'CLAIMS_CLAIMDETAIL_INIT_FAIL'
// export const CLAIMS_CLAIMDETAIL_SAVE_LOADING = 'CLAIMS_CLAIMDETAIL_SAVE_LOADING'
// export const CLAIMS_CLAIMDETAIL_SAVE_SUCCESS = 'CLAIMS_CLAIMDETAIL_SAVE_SUCCESS'
// export const CLAIMS_CLAIMDETAIL_SAVE_FAIL = 'CLAIMS_CLAIMDETAIL_SAVE_FAIL'
// export const CLAIMS_CLAIMDETAIL_LOAD_DATA = 'CLAIMS_CLAIMDETAIL_LOAD_DATA'
// export const CLAIMS_CLAIMDETAIL_LEAVECLAIM = 'CLAIMS_CLAIMDETAIL_LEAVECLAIM'
export const CLAIMS_CLAIMDETAIL_CLAIMHANDLERS = 'CLAIMS_CLAIMDETAIL_CLAIMHANDLERS'
// export const CLAIMS_CLAIMDETAIL_CLAIMANT = 'CLAIMS_CLAIMDETAIL_CLAIMANT'
// export const CLAIMS_CLAIMDETAIL_CLAIMITEM = 'CLAIMS_CLAIMDETAIL_CLAIMITEM'
export const CLAIMS_CLAIMDETAIL_SERVICEPROVIDER = 'CLAIMS_CLAIMDETAIL_SERVICEPROVIDER'
export const CLAIMS_CLAIMDETAIL_RESERVES = 'CLAIMS_CLAIMDETAIL_RESERVES'
export const CLAIMS_CLAIMPAYMENT_SELECTEDRESERVES = 'CLAIMS_CLAIMPAYMENT_SELECTEDRESERVES'
export const CLAIMS_PARAMS_SUCCESS = 'CLAIMS_PARAMS_SUCCESS'
export const CLAIMS_PARAMS_FAIL = 'CLAIMS_PARAMS_FAIL'
export const CLAIMS_PARAMS_RESERVES_SUCCESS = 'CLAIMS_PARAMS_RESERVES_SUCCESS'
export const CLAIMS_PARAMS_RESERVES_FAIL = 'CLAIMS_PARAMS_RESERVES_FAIL'
export const CLAIMS_REGISTER_INIT_LOADING = 'CLAIMS_REGISTER_INIT_LOADING'
export const CLAIMS_REGISTER_INIT_SUCCESS = 'CLAIMS_REGISTER_INIT_SUCCESS'
export const CLAIMS_REGISTER_INIT_FAIL = 'CLAIMS_REGISTER_INIT_FAIL'
// export const CLAIMS_LISTING_INIT_LOADING = 'CLAIMS_LISTING_INIT_LOADING'
// export const CLAIMS_LISTING_INIT_SUCCESS = 'CLAIMS_LISTING_INIT_SUCCESS'
// export const CLAIMS_LISTING_INIT_FAIL = 'CLAIMS_LISTING_INIT_FAIL'
export const CLAIMS_LIFECYCLE = 'CLAIMS_LIFECYCLE'
export const CLAIMS_LEAVEQUOTE = 'CLAIMS_LEAVEQUOTE'
export const CLAIMS_HASRIORRESADJ = 'CLAIMS_HASRIORRESADJ'
export const CLAIMS_HASRIORRESADJ_LOADING = 'CLAIMS_HASRIORRESADJ_LOADING'
export const UPDATE_CLM_PEND_EXIST_LIST = 'UPDATE_CLM_PEND_EXIST_LIST'

// RiOutwards
export const RI_LOADING = 'RI_LOADING'
export const RI_SUCCESS = 'RI_SUCCESS'
export const RI_FAIL = 'RI_FAIL'
export const RI_LISTING_LOADING = 'RI_LISTING_LOADING'
export const RI_LISTING_SUCCESS = 'RI_LISTING_SUCCESS'
export const RI_LISTING_FAIL = 'RI_LISTING_FAIL'
export const RI_DETAIL_LOAD_DATA = 'RI_DETAIL_LOAD_DATA'
export const RI_DETAIL_LISTING_LOADING = 'RI_DETAIL_LISTING_LOADING'
export const RI_DETAIL_LISTING_SUCCESS = 'RI_DETAIL_LISTING_SUCCESS'
export const RI_DETAIL_LISTING_FAIL = 'RI_DETAIL_LISTING_FAIL'

// RiskAccumulation
export const RISKACCUMULATION_LOADING = 'RISKACCUMULATION_LOADING'
export const RISKACCUMULATION_SUCCESS = 'RISKACCUMULATION_SUCCESS'
export const RISKACCUMULATION_FAIL = 'RISKACCUMULATION_FAIL'
export const RISKACCUMULATIONLIST_SUCCESS = 'RISKACCUMULATIONLIST_SUCCESS'
export const RISKACCUMULATIONLIST_LOADING = 'RISKACCUMULATIONLIST_LOADING'
export const RISKACCUMULATIONLIST_FAIL = 'RISKACCUMULATIONLIST_FAIL'

// Underwriting
export const UNDERWRITING_INIT_LOADING = 'UNDERWRITING_INIT_LOADING'
export const UNDERWRITING_INIT_SUCCESS = 'UNDERWRITING_INIT_SUCCESS'
export const UNDERWRITING_INIT_FAIL = 'UNDERWRITING_INIT_FAIL'
export const POLICY_RESET = 'POLICY_RESET'
export const POLICY_NEW_MODE = 'POLICY_NEW_MODE'
export const POLICY_REVIEW_MODE = 'POLICY_REVIEW_MODE'
export const POLICY_RENEWAL_MODE = 'POLICY_RENEWAL_MODE'
export const POLICY_ENDORSEMENT_MODE = 'POLICY_ENDORSEMENT_MODE'
export const POLICY_CANCELLATION_MODE = 'POLICY_CANCELLATION_MODE'
export const POLICYGENERAL_INIT_LOADING = 'POLICYGENERAL_INIT_LOADING'
export const POLICYGENERAL_INIT_SUCCESS = 'POLICYGENERAL_INIT_SUCCESS'
export const POLICYGENERAL_INIT_FAIL = 'POLICYGENERAL_INIT_FAIL'
export const POLICYGENERAL_SAVE_LOADING = 'POLICYGENERAL_SAVE_LOADING'
export const POLICYGENERAL_SAVE_SUCCESS = 'POLICYGENERAL_SAVE_SUCCESS'
export const POLICYGENERAL_SAVE_FAIL = 'POLICYGENERAL_SAVE_FAIL'
export const POLICYGENERAL_UPDATE_RIOUTMASTER_TRANDATE_LOADING = 'POLICYGENERAL_UPDATE_RIOUTMASTER_TRANDATE_LOADING'
export const POLICYGENERAL_UPDATE_RIOUTMASTER_TRANDATE_SUCCESS = 'POLICYGENERAL_UPDATE_RIOUTMASTER_TRANDATE_SUCCESS'
export const POLICYGENERAL_UPDATE_RIOUTMASTER_TRANDATE_FAIL = 'POLICYGENERAL_UPDATE_RIOUTMASTER_TRANDATE_FAIL'
export const POLICYGENERAL_LOAD_DATA = 'POLICYGENERAL_LOAD_DATA'
export const POLICY_LIFECYCLE = 'POLICY_LIFECYCLE'
export const POLICYHEADER_INIT_LOADING = 'POLICYHEADER_INIT_LOADING'
export const POLICYHEADER_INIT_SUCCESS = 'POLICYHEADER_INIT_SUCCESS'
export const POLICYHEADER_INIT_FAIL = 'POLICYHEADER_INIT_FAIL'
export const POLICY_HEADER_TAB = 'POLICY_HEADER_TAB'
export const POLICY_GENERAL = 'POLICY_GENERAL'
export const POLICY_MAIN = 'POLICY_MAIN'
export const POLICY_INSURED = 'POLICY_INSURED'
export const POLICY_OTHER_DETALS = 'POLICY_OTHER_DETALS'
export const POLICYRISKGROUP_INIT_LOADING = 'POLICYRISKGROUP_INIT_LOADING'
export const POLICYRISKGROUP_INIT_SUCCESS = 'POLICYRISKGROUP_INIT_SUCCESS'
export const POLICYRISKGROUP_INIT_FAIL = 'POLICYRISKGROUP_INIT_FAIL'
export const POLICY_RISK_GROUP = 'POLICY_RISK_GROUP'
export const POLICYRISKGROUP_SAVE_LOADING = 'POLICYRISKGROUP_SAVE_LOADING'
export const POLICYRISKGROUP_SAVE_SUCCESS = 'POLICYRISKGROUP_SAVE_SUCCESS'
export const POLICYRISKGROUP_SAVE_FAIL = 'POLICYRISKGROUP_SAVE_FAIL'
export const POLICYRISKGROUP_LIST = 'POLICYRISKGROUP_LIST'
export const POLINSDDET_SAVE_LOADING = 'POLINSDDET_SAVE_LOADING'
export const POLINSDDET_SAVE_SUCCESS = 'POLINSDDET_SAVE_SUCCESS'
export const POLINSDDET_SAVE_FAIL = 'POLINSDDET_SAVE_FAIL'
export const POLINSDDET_LIST = 'POLINSDDET_LIST'
export const UNDERWRITING_DOC_INIT_LOADING = 'UNDERWRITING_DOC_INIT_LOADING'
export const UNDERWRITING_DOC_INIT_SUCCESS = 'UNDERWRITING_DOC_INIT_SUCCESS'
export const UNDERWRITING_DOC_INIT_FAIL = 'UNDERWRITING_DOC_INIT_FAIL'
export const POLCRCD_SAVE_LOADING = 'POLCRCD_SAVE_LOADING'
export const POLCRCD_SAVE_SUCCESS = 'POLCRCD_SAVE_SUCCESS'
export const POLCRCD_SAVE_FAIL = 'POLCRCD_SAVE_FAIL'
export const POLCRCD_LOAD_DATA = 'POLCRCD_LOAD_DATA'
export const POLBANKDR_SAVE_LOADING = 'POLBANKDR_SAVE_LOADING'
export const POLBANKDR_SAVE_SUCCESS = 'POLBANKDR_SAVE_SUCCESS'
export const POLBANKDR_SAVE_FAIL = 'POLBANKDR_SAVE_FAIL'
export const POLBANKDR_LOAD_DATA = 'POLBANKDR_LOAD_DATA'
export const POLCLSE_SAVE_LOADING = 'POLCLSE_SAVE_LOADING'
export const POLCLSE_SAVE_SUCCESS = 'POLCLSE_SAVE_SUCCESS'
export const POLCLSE_SAVE_FAIL = 'POLCLSE_SAVE_FAIL'
export const POLHDRSTATS_SAVE_LOADING = 'POLHDRSTATS_SAVE_LOADING'
export const POLHDRSTATS_SAVE_SUCCESS = 'POLHDRSTATS_SAVE_SUCCESS'
export const POLHDRSTATS_SAVE_FAIL = 'POLHDRSTATS_SAVE_FAIL'
export const POLICYRISK_INIT_LOADING = 'POLICYRISK_INIT_LOADING'
export const POLICYRISK_INIT_SUCCESS = 'POLICYRISK_INIT_SUCCESS'
export const POLICYRISK_INIT_FAIL = 'POLICYRISK_INIT_FAIL'
export const POLICYRISK_SAVE_LOADING = 'POLICYRISK_SAVE_LOADING'
export const POLICYRISK_SAVE_SUCCESS = 'POLICYRISK_SAVE_SUCCESS'
export const POLICYRISK_SAVE_FAIL = 'POLICYRISK_SAVE_FAIL'
export const POLICYRISK_LIST = 'POLICYRISK_LIST'
export const RISKCLSE_SAVE_LOADING = 'RISKCLSE_SAVE_LOADING'
export const RISKCLSE_SAVE_SUCCESS = 'RISKCLSE_SAVE_SUCCESS'
export const RISKCLSE_SAVE_FAIL = 'RISKCLSE_SAVE_FAIL'
export const POLRISKSTATS_SAVE_LOADING = 'POLRISKSTATS_SAVE_LOADING'
export const POLRISKSTATS_SAVE_SUCCESS = 'POLRISKSTATS_SAVE_SUCCESS'
export const POLRISKSTATS_SAVE_FAIL = 'POLRISKSTATS_SAVE_FAIL'
export const POLICYFIRERISK_INIT_LOADING = 'POLICYFIRERISK_INIT_LOADING'
export const POLICYFIRERISK_INIT_SUCCESS = 'POLICYFIRERISK_INIT_SUCCESS'
export const POLICYFIRERISK_INIT_FAIL = 'POLICYFIRERISK_INIT_FAIL'
export const POLICYFIRERISK_SAVE_LOADING = 'POLICYFIRERISK_SAVE_LOADING'
export const POLICYFIRERISK_SAVE_SUCCESS = 'POLICYFIRERISK_SAVE_SUCCESS'
export const POLICYFIRERISK_SAVE_FAIL = 'POLICYFIRERISK_SAVE_FAIL'
export const POLICY_RISK_TAB = 'POLICY_RISK_TAB'
export const POLICYBONDRISK_INIT_LOADING = 'POLICYBONDRISK_INIT_LOADING'
export const POLICYBONDRISK_INIT_SUCCESS = 'POLICYBONDRISK_INIT_SUCCESS'
export const POLICYBONDRISK_INIT_FAIL = 'POLICYBONDRISK_INIT_FAIL'
export const POLICYMISCWRKMAN_SAVE_LOADING = 'POLICYMISCWRKMAN_SAVE_LOADING'
export const POLICYMISCWRKMAN_SAVE_SUCCESS = 'POLICYMISCWRKMAN_SAVE_SUCCESS'
export const POLICYMISCWRKMAN_SAVE_FAIL = 'POLICYMISCWRKMAN_SAVE_FAIL'
export const POLICYMISCWRKMAN_LIST = 'POLICYMISCWRKMAN_LIST'
export const POLICYMISCEMPYT_SAVE_LOADING = 'POLICYMISCEMPYT_SAVE_LOADING'
export const POLICYMISCEMPYT_SAVE_SUCCESS = 'POLICYMISCEMPYT_SAVE_SUCCESS'
export const POLICYMISCEMPYT_SAVE_FAIL = 'POLICYMISCEMPYT_SAVE_FAIL'
export const POLICYMOTORRISK_INIT_LOADING = 'POLICYMOTORRISK_INIT_LOADING'
export const POLICYMOTORRISK_INIT_SUCCESS = 'POLICYMOTORRISK_INIT_SUCCESS'
export const POLICYMOTORRISK_INIT_FAIL = 'POLICYMOTORRISK_INIT_FAIL'
export const POLICYMOTORRISK_SAVE_LOADING = 'POLICYMOTORRISK_SAVE_LOADING'
export const POLICYMOTORRISK_SAVE_SUCCESS = 'POLICYMOTORRISK_SAVE_SUCCESS'
export const POLICYMOTORRISK_SAVE_FAIL = 'POLICYMOTORRISK_SAVE_FAIL'
export const POLICYMOTORDRIVER_SAVE_LOADING = 'POLICYMOTORDRIVER_SAVE_LOADING'
export const POLICYMOTORDRIVER_SAVE_SUCCESS = 'POLICYMOTORDRIVER_SAVE_SUCCESS'
export const POLICYMOTORDRIVER_SAVE_FAIL = 'POLICYMOTORDRIVER_SAVE_FAIL'
export const POLICYMOTORDRIVER_LIST = 'POLICYMOTORDRIVER_LIST'
export const POLICYHULLRISK_INIT_LOADING = 'POLICYHULLRISK_INIT_LOADING'
export const POLICYHULLRISK_INIT_SUCCESS = 'POLICYHULLRISK_INIT_SUCCESS'
export const POLICYHULLRISK_INIT_FAIL = 'POLICYHULLRISK_INIT_FAIL'
export const POLICYHULLRISK_SAVE_LOADING = 'POLICYHULLRISK_SAVE_LOADING'
export const POLICYHULLRISK_SAVE_SUCCESS = 'POLICYHULLRISK_SAVE_SUCCESS'
export const POLICYHULLRISK_SAVE_FAIL = 'POLICYHULLRISK_SAVE_FAIL'
export const POLICYCARGORISK_INIT_LOADING = 'POLICYCARGORISK_INIT_LOADING'
export const POLICYCARGORISK_INIT_SUCCESS = 'POLICYCARGORISK_INIT_SUCCESS'
export const POLICYCARGORISK_INIT_FAIL = 'POLICYCARGORISK_INIT_FAIL'
export const POLICYCARGORISK_SAVE_LOADING = 'POLICYCARGORISK_SAVE_LOADING'
export const POLICYCARGORISK_SAVE_SUCCESS = 'POLICYCARGORISK_SAVE_SUCCESS'
export const POLICYCARGORISK_SAVE_FAIL = 'POLICYCARGORISK_SAVE_FAIL'
export const POLICYRISKITEM_INIT_LOADING = 'POLICYRISKITEM_INIT_LOADING'
export const POLICYRISKITEM_INIT_SUCCESS = 'POLICYRISKITEM_INIT_SUCCESS'
export const POLICYRISKITEM_INIT_FAIL = 'POLICYRISKITEM_INIT_FAIL'
export const POLICY_SELECTED_RISKGRPNO = 'POLICY_SELECTED_RISKGRPNO'
export const POLICY_SELECTED_RISKNO = 'POLICY_SELECTED_RISKNO'
export const POLICY_SELECTED_ITEMNO = 'POLICY_SELECTED_ITEMNO'
export const POLICY_SELECTED_PLANNO = 'POLICY_SELECTED_PLANNO'
export const POLITEM_SAVE_LOADING = 'POLITEM_SAVE_LOADING'
export const POLITEM_SAVE_SUCCESS = 'POLITEM_SAVE_SUCCESS'
export const POLITEM_SAVE_FAIL = 'POLITEM_SAVE_FAIL'
export const POLITEMSTATS_SAVE_LOADING = 'POLITEMSTATS_SAVE_LOADING'
export const POLITEMSTATS_SAVE_SUCCESS = 'POLITEMSTATS_SAVE_SUCCESS'
export const POLITEMSTATS_SAVE_FAIL = 'POLITEMSTATS_SAVE_FAIL'
export const POLITEMUOM_SAVE_LOADING = 'POLITEMUOM_SAVE_LOADING'
export const POLITEMUOM_SAVE_SUCCESS = 'POLITEMUOM_SAVE_SUCCESS'
export const POLITEMUOM_SAVE_FAIL = 'POLITEMUOM_SAVE_FAIL'
export const POLITEM_SET_DATA = 'POLITEM_SET_DATA'
export const POLITEMUOM_SET_DATA = 'POLITEMUOM_SET_DATA'
export const POLSUBITEM_INIT_LOADING = 'POLSUBITEM_INIT_LOADING'
export const POLSUBITEM_INIT_SUCCESS = 'POLSUBITEM_INIT_SUCCESS'
export const POLSUBITEM_INIT_FAIL = 'POLSUBITEM_INIT_FAIL'
export const POLSUBITEM_SAVE_LOADING = 'POLSUBITEM_SAVE_LOADING'
export const POLSUBITEM_SAVE_SUCCESS = 'POLSUBITEM_SAVE_SUCCESS'
export const POLSUBITEM_SAVE_FAIL = 'POLSUBITEM_SAVE_FAIL'
export const POLICY_COVERAGE = 'POLICY_COVERAGE'
export const POLICY_COVERAGE_DISCLDG = 'POLICY_COVERAGE_DISCLDG'
export const POLICY_COVERAGE_DISCLDG_PD_GAP_CEDSI_AND_OUR_SHARE_SI = 'POLICY_COVERAGE_DISCLDG_PD_GAP_CEDSI_AND_OUR_SHARE_SI'
export const POLITEMBEN_SAVE_LOADING = 'POLITEMBEN_SAVE_LOADING'
export const POLITEMBEN_SAVE_SUCCESS = 'POLITEMBEN_SAVE_SUCCESS'
export const POLITEMBEN_SAVE_FAIL = 'POLITEMBEN_SAVE_FAIL'
export const POLICY_SUMMARY_TAB = 'POLICY_SUMMARY_TAB'
export const POLSUMMARY_INIT_LOADING = 'POLSUMMARY_INIT_LOADING'
export const POLSUMMARY_INIT_SUCCESS = 'POLSUMMARY_INIT_SUCCESS'
export const POLSUMMARY_INIT_FAIL = 'POLSUMMARY_INIT_FAIL'
export const POLICYQUERY_INIT_LOADING = 'POLICYQUERY_INIT_LOADING'
export const POLICYQUERY_INIT_SUCCESS = 'POLICYQUERY_INIT_SUCCESS'
export const POLICYQUERY_INIT_FAIL = 'POLICYQUERY_INIT_FAIL'
export const DATATRANSFER_INIT_LOADING = 'DATATRANSFER_INIT_LOADING'
export const DATATRANSFER_INIT_SUCCESS = 'DATATRANSFER_INIT_SUCCESS'
export const DATATRANSFER_INIT_FAIL = 'DATATRANSFER_INIT_FAIL'
export const SPECIALFUNCUW_INIT_LOADING = 'SPECIALFUNCUW_INIT_LOADING'
export const SPECIALFUNCUW_INIT_SUCCESS = 'SPECIALFUNCUW_INIT_SUCCESS'
export const SPECIALFUNCUW_INIT_FAIL = 'SPECIALFUNCUW_INIT_FAIL'
export const POLRISKBLK_SAVE_LOADING = 'POLRISKBLK_SAVE_LOADING'
export const POLRISKBLK_SAVE_SUCCESS = 'POLRISKBLK_SAVE_SUCCESS'
export const POLRISKBLK_SAVE_FAIL = 'POLRISKBLK_SAVE_FAIL'
export const POLICY_LEAVE = 'POLICY_LEAVE'
export const RISKTRAILER_SAVE_LOADING = 'RISKTRAILER_SAVE_LOADING'
export const RISKTRAILER_SAVE_SUCCESS = 'RISKTRAILER_SAVE_SUCCESS'
export const RISKTRAILER_SAVE_FAIL = 'RISKTRAILER_SAVE_FAIL'
export const POLICY_ADDITIONAL_SETTINGS = 'POLICY_ADDITIONAL_SETTINGS'
export const POLICY_TOTALS = 'POLICY_TOTALS'
export const PREMINSTALBILL_SAVE_LOADING = 'PREMINSTALBILL_SAVE_LOADING'
export const PREMINSTALBILL_SAVE_SUCCESS = 'PREMINSTALBILL_SAVE_SUCCESS'
export const PREMINSTALBILL_SAVE_FAIL = 'PREMINSTALBILL_SAVE_FAIL'
export const DELETEPOLICY_INIT_LOADING = 'DELETEPOLICY_INIT_LOADING'
export const DELETEPOLICY_INIT_FAIL = 'DELETEPOLICY_INIT_FAIL'
export const DELETEPOLICY_INIT_SUCCESS = 'DELETEPOLICY_INIT_SUCCESS'
export const POLICY_REINSURANCE_TAB = 'POLICY_REINSURANCE_TAB'
export const POLICY_REINSURANCE_RI_HEADER = 'POLICY_REINSURANCE_RI_HEADER'
export const POLICY_DOCUMENT_PRINT_SECTION = 'POLICY_DOCUMENT_PRINT_SECTION'
export const POLBORDITEM_SAVE_LOADING = 'POLBORDITEM_SAVE_LOADING'
export const POLBORDITEM_SAVE_SUCCESS = 'POLBORDITEM_SAVE_SUCCESS'
export const POLBORDITEM_SAVE_FAIL = 'POLBORDITEM_SAVE_FAIL'
export const POLEMPYEEDET_SAVE_LOADING = 'POLEMPYEEDET_SAVE_LOADING'
export const POLEMPYEEDET_SAVE_SUCCESS = 'POLEMPYEEDET_SAVE_SUCCESS'
export const POLEMPYEEDET_SAVE_FAIL = 'POLEMPYEEDET_SAVE_FAIL'
export const RISK_SURVEY_NEW_MODE = 'RISK_SURVEY_NEW_MODE'
export const RISK_SURVEY_REVIEW_MODE = 'RISK_SURVEY_REVIEW_MODE'
export const RISK_SURVEY_QUERY_MODE = 'RISK_SURVEY_QUERY_MODE'
export const RISK_SURVEY_ENDORSEMENT_MODE = 'RISK_SURVEY_ENDORSEMENT_MODE'
export const RISK_SURVEY_TAB = 'RISK_SURVEY_TAB'
export const RISK_SURVEY_MASTER = 'RISK_SURVEY_MASTER'
export const RISK_SURVEY_DETAILS = 'RISK_SURVEY_DETAILS'
export const RISK_SURVEY_INIT_LOADING = 'RISK_SURVEY_INIT_LOADING'
export const RISK_SURVEY_INIT_SUCCESS = 'RISK_SURVEY_INIT_SUCCESS'
export const RISK_SURVEY_INIT_FAIL = 'RISK_SURVEY_INIT_FAIL'
export const RESET_RISK_SURVEY_MASTER = 'RESET_RISK_SURVEY_MASTER'
export const RESET_RISK_SURVEY_DETAILS = 'RESET_RISK_SURVEY_DETAILS'
export const COINS_SVC_FEE = 'COINS_SVC_FEE'
export const COINS_SVC_INIT_LOADING = 'COINS_SVC_INIT_LOADING'
export const COINS_SVC_INIT_SUCCESS = 'COINS_SVC_INIT_SUCCESS'
export const COINS_SVC_INIT_FAIL = 'COINS_SVC_INIT_FAIL'
export const COINS_SVC_SAVE_LOADING = 'COINS_SVC_SAVE_LOADING'
export const COINS_SVC_SAVE_SUCCESS = 'OINS_SVC_SAVE_SUCCESS'
export const COINS_SVC_SAVE_FAIL = 'COINS_SVC_SAVE_FAIL'

// Normalisation of Surplus Treaties
export const NORM_TREATY_SURPLUS_INIT_LOADING = 'NORM_TREATY_SURPLUS_INIT_LOADING'
export const NORM_TREATY_SURPLUS_INIT_SUCCESS = 'NORM_TREATY_SURPLUS_INIT_SUCCESS'
export const NORM_TREATY_SURPLUS_INIT_FAIL = 'NORM_TREATY_SURPLUS_INIT_FAIL'
export const NORM_TREATY_SURPLUS_ACCUM_TYPES = 'NORM_TREATY_SURPLUS_ACCUM_TYPES'

// Business Class
export const BUSCLSPARAM_INIT_LOADING = 'BUSCLSPARAM_INIT_LOADING'
export const BUSCLSPARAM_INIT_SUCCESS = 'BUSCLSPARAM_INIT_SUCCESS'
export const BUSCLSPARAM_INIT_FAIL = 'BUSCLSPARAM_INIT_FAIL'
export const BUSCLSPARAM_BUSCLSGRPLIST = 'BUSCLSPARAM_BUSCLSGRPLIST'
export const BUSCLSPARAM_GLANCODELIST = 'BUSCLSPARAM_GLANCODELIST'
export const BUSCLSPARAM_ACCUMTYPELIST = 'BUSCLSPARAM_ACCUMTYPELIST'
export const BUSCLSPARAM_TARIFFLIST = 'BUSCLSPARAM_TARIFFLIST'
export const BUSCLSPARAM_VEHGRPLIST = 'BUSCLSPARAM_VEHGRPLIST'
export const BUSCLSPARAM_VEHUSGLIST = 'BUSCLSPARAM_VEHUSGLIST'

// Admin User
export const ADMINUSER_INIT_LOADING = 'ADMINUSER_INIT_LOADING'
export const ADMINUSER_INIT_SUCCESS = 'ADMINUSER_INIT_SUCCESS'
export const ADMINUSER_INIT_FAIL = 'ADMINUSER_INIT_FAIL'
export const ADMINUSER_INTERMEDIARY = 'ADMINUSER_INTERMEDIARY'
export const ADMINUSER_SECURITY_LOADING = 'ADMINUSER_SECURITY_LOADING'
export const ADMINUSER_SECURITY_SUCCESS = 'ADMINUSER_SECURITY_SUCCESS'
export const ADMINUSER_SECURITY_FAIL = 'ADMINUSER_SECURITY_FAIL'
export const ADMINUSER_PRIVILEGE_LOADING = 'ADMINUSER_PRIVILEGE_LOADING'
export const ADMINUSER_PRIVILEGE_SUCCESS = 'ADMINUSER_PRIVILEGE_SUCCESS'
export const ADMINUSER_PRIVILEGE_FAIL = 'ADMINUSER_PRIVILEGE_FAIL'

// Admin Intermediary
export const ADMININTERMEDIARY_INIT_LOADING = 'ADMININTERMEDIARY_INIT_LOADING'
export const ADMININTERMEDIARY_INIT_SUCCESS = 'ADMININTERMEDIARY_INIT_SUCCESS'
export const ADMININTERMEDIARY_INIT_FAIL = 'ADMININTERMEDIARY_INIT_FAIL'
export const ADMININTERMEDIARY_INTERGROUPLIST = 'ADMININTERMEDIARY_INTERGROUPLIST'
export const ADMININTERMEDIARY_MENU_INIT_LOADING = 'ADMININTERMEDIARY_MENU_INIT_LOADING'
export const ADMININTERMEDIARY_MENU_INIT_SUCCESS = 'ADMININTERMEDIARY_MENU_INIT_SUCCESS'
export const ADMININTERMEDIARY_MENU_INIT_FAIL = 'ADMININTERMEDIARY_MENU_INIT_FAIL'

// Admin Insured
export const ADMININSURED_INIT_LOADING = 'ADMININSURED_INIT_LOADING'
export const ADMININSURED_INIT_SUCCESS = 'ADMININSURED_INIT_SUCCESS'
export const ADMININSURED_INIT_FAIL = 'ADMININSURED_INIT_FAIL'
export const ADMININSURED_MENU_INIT_LOADING = 'ADMININSURED_MENU_INIT_LOADING'
export const ADMININSURED_MENU_INIT_SUCCESS = 'ADMININSURED_MENU_INIT_SUCCESS'
export const ADMININSURED_MENU_INIT_FAIL = 'ADMININSURED_MENU_INIT_FAIL'

// UW
export const UWPARAM_INIT_LOADING = 'UWPARAM_INIT_LOADING'
export const UWPARAM_INIT_SUCCESS = 'UWPARAM_INIT_SUCCESS'
export const UWPARAM_INIT_FAIL = 'UWPARAM_INIT_FAIL'
export const POLTYPE_INIT_LOADING = 'POLTYPE_INIT_LOADING'
export const POLTYPE_INIT_SUCCESS = 'POLTYPE_INIT_SUCCESS'
export const POLTYPE_INIT_FAIL = 'POLTYPE_INIT_FAIL'
export const DEPT_INIT_LOADING = 'DEPT_INIT_LOADING'
export const DEPT_INIT_SUCCESS = 'DEPT_INIT_SUCCESS'
export const DEPT_INIT_FAIL = 'DEPT_INIT_FAIL'

// Branch Param
export const BRANCHPARAM_INIT_LOADING = 'BRANCHPARAM_INIT_LOADING'
export const BRANCHPARAM_INIT_SUCCESS = 'BRANCHPARAM_INIT_SUCCESS'
export const BRANCHPARAM_INIT_FAIL = 'BRANCHPARAM_INIT_FAIL'
export const BRANCHPARAM_COUNTRYLIST = 'BRANCHPARAM_COUNTRYLIST'
export const BRANCHPARAM_BANKLIST = 'BRANCHPARAM_BANKLIST'
export const BRANCHPARAM_GSTKEYBRNLIST = 'BRANCHPARAM_GSTKEYBRNLIST'
export const BRANCHPARAM_MAINFORM = 'BRANCHPARAM_MAINFORM'
export const BRANCHPARAM_LEAVEQUOTE = 'BRANCHPARAM_LEAVEQUOTE'
export const BRANCHPARAM_NEWBRANCH = 'BRANCHPARAM_NEWBRANCH'

// Misc
export const MISCPARAMS_INIT_LOADING = 'MISCPARAMS_INIT_LOADING'
export const MISCPARAMS_INIT_SUCCESS = 'MISCPARAMS_INIT_SUCCESS'
export const MISCPARAMS_INIT_FAIL = 'MISCPARAMS_INIT_FAIL'

// Transaction Date Range
export const TRANSACTIONDATERANGE_INIT_LOADING = 'TRANSACTIONDATERANGE_INIT_LOADING'
export const TRANSACTIONDATERANGE_INIT_SUCCESS = 'TRANSACTIONDATERANGE_INIT_SUCCESS'
export const TRANSACTIONDATERANGE_INIT_FAIL = 'TRANSACTIONDATERANGE_INIT_FAIL'

// Tariff
export const TARIFF_INIT_LOADING = 'TARIFF_INIT_LOADING'
export const TARIFF_INIT_SUCCESS = 'TARIFF_INIT_SUCCESS'
export const TARIFF_INIT_FAIL = 'TARIFF_INIT_FAIL'

// Fund
export const FUND_INIT_LOADING = 'FUND_INIT_LOADING'
export const FUND_INIT_SUCCESS = 'FUND_INIT_SUCCESS'
export const FUND_INIT_FAIL = 'FUND_INIT_FAIL'

// Currency
export const CURRENCYPARAM_INIT_LOADING = 'CURRENCYPARAM_INIT_LOADING'
export const CURRENCYPARAM_INIT_SUCCESS = 'CURRENCYPARAM_INIT_SUCCESS'
export const CURRENCYPARAM_INIT_FAIL = 'CURRENCYPARAM_INIT_FAIL'

// Country
export const CTY_INIT_LOADING = 'CTY_INIT_LOADING'
export const CTY_INIT_SUCCESS = 'CTY_INIT_SUCCESS'
export const CTY_INIT_FAIL = 'CTY_INIT_FAIL'

// Country Zone
export const CTYZONE_INIT_LOADING = 'CTYZONE_INIT_LOADING'
export const CTYZONE_INIT_SUCCESS = 'CTYZONE_INIT_SUCCESS'
export const CTYZONE_INIT_FAIL = 'CTYZONE_INIT_FAIL'

// Company
export const COMPANY_INIT_LOADING = 'COMPANY_INIT_LOADING'
export const COMPANY_INIT_SUCCESS = 'COMPANY_INIT_SUCCESS'
export const COMPANY_INIT_FAIL = 'COMPANY_INIT_FAIL'

// GL Account
export const GLACCT_INIT_LOADING = 'GLACCT_INIT_LOADING'
export const GLACCT_INIT_SUCCESS = 'GLACCT_INIT_SUCCESS'
export const GLACCT_INIT_FAIL = 'GLACCT_INIT_FAIL'
export const GLACCT_HELPLIST = 'GLACCT_HELPLIST'
export const GLMAPPING_COMMIT_KEY = 'GLMAPPING_COMMIT_KEY'
export const GLACCTNO_COMMIT_KEY = 'GLACCTNO_COMMIT_KEY'

// GL Analyisis Code
export const GLANCODE_INIT_LOADING = 'GLANCODE_INIT_LOADING'
export const GLANCODE_INIT_SUCCESS = 'GLANCODE_INIT_SUCCESS'
export const GLANCODE_INIT_FAIL = 'GLANCODE_INIT_FAIL'
export const GLANCODE_COMMIT_KEY = 'GLANCODE_COMMIT_KEY'

// Paytment Method
export const PAYTMETH_INIT_LOADING = 'PAYTMETH_INIT_LOADING'
export const PAYTMETH_INIT_SUCCESS = 'PAYTMETH_INIT_SUCCESS'
export const PAYTMETH_INIT_FAIL = 'PAYTMETH_INIT_FAIL'
export const PAYTMETH_BANKLIST = 'PAYTMETH_BANKLIST'

// Unit of Measure
export const UOM_INIT_LOADING = 'UOM_INIT_LOADING'
export const UOM_INIT_SUCCESS = 'UOM_INIT_SUCCESS'
export const UOM_INIT_FAIL = 'UOM_INIT_FAIL'

// Package
export const PACKAGE_INIT_LOADING = 'PACKAGE_INIT_LOADING'
export const PACKAGE_INIT_SUCCESS = 'PACKAGE_INIT_SUCCESS'
export const PACKAGE_INIT_FAIL = 'PACKAGE_INIT_FAIL'
export const SCHEME_INIT_LOADING = 'SCHEME_INIT_LOADING'
export const SCHEME_INIT_SUCCESS = 'SCHEME_INIT_SUCCESS'
export const SCHEME_INIT_FAIL = 'SCHEME_INIT_FAIL'
export const POLTYPESCHEME_INIT_LOADING = 'POLTYPESCHEME_INIT_LOADING'
export const POLTYPESCHEME_INIT_SUCCESS = 'POLTYPESCHEME_INIT_SUCCESS'
export const POLTYPESCHEME_INIT_FAIL = 'POLTYPESCHEME_INIT_FAIL'
export const TARIFFBEN_INIT_LOADING = 'TARIFFBEN_INIT_LOADING'
export const TARIFFBEN_INIT_SUCCESS = 'TARIFFBEN_INIT_SUCCESS'
export const TARIFFBEN_INIT_FAIL = 'TARIFFBEN_INIT_FAIL'
export const TARIFFBEN_COMMIT_KEY = 'TARIFFBEN_COMMIT_KEY'
export const TARIFFFACT_INIT_LOADING = 'TARIFFFACT_INIT_LOADING'
export const TARIFFFACT_INIT_SUCCESS = 'TARIFFFACT_INIT_SUCCESS'
export const TARIFFFACT_INIT_FAIL = 'TARIFFFACT_INIT_FAIL'
export const TARIFFFACT_COMMIT_KEY = 'TARIFFFACT_COMMIT_KEY'
export const PACKAGEPLAN_INIT_LOADING = 'PACKAGEPLAN_INIT_LOADING'
export const PACKAGEPLAN_INIT_SUCCESS = 'PACKAGEPLAN_INIT_SUCCESS'
export const PACKAGEPLAN_INIT_FAIL = 'PACKAGEPLAN_INIT_FAIL'
export const PACKAGEPLAN_COMMIT_KEY = 'PACKAGEPLAN_COMMIT_KEY'
export const TARIFFRATE_INIT_LOADING = 'TARIFFRATE_INIT_LOADING'
export const TARIFFRATE_INIT_SUCCESS = 'TARIFFRATE_INIT_SUCCESS'
export const TARIFFRATE_INIT_FAIL = 'TARIFFRATE_INIT_FAIL'
export const TARIFFRATE_COMMIT_KEY = 'TARIFFRATE_COMMIT_KEY'
export const PKGSTDRISKTXT_INIT_LOADING = 'PKGSTDRISKTXT_INIT_LOADING'
export const PKGSTDRISKTXT_INIT_SUCCESS = 'PKGSTDRISKTXT_INIT_SUCCESS'
export const PKGSTDRISKTXT_INIT_FAIL = 'PKGSTDRISKTXT_INIT_FAIL'
export const PKGSTDRISKTXT_COMMIT_KEY = 'PKGSTDRISKTXT_COMMIT_KEY'
export const PACKAGERISK_COMMIT_KEY = 'PACKAGERISK_COMMIT_KEY'
export const PACKAGERISKITEM_COMMIT_KEY = 'PACKAGERISKITEM_COMMIT_KEY'
export const PACKAGERISKSUBITEM_COMMIT_KEY = 'PACKAGERISKSUBITEM_COMMIT_KEY'
export const PKGSTDITEMTXT_INIT_LOADING = 'PKGSTDITEMTXT_INIT_LOADING'
export const PKGSTDITEMTXT_INIT_SUCCESS = 'PKGSTDITEMTXT_INIT_SUCCESS'
export const PKGSTDITEMTXT_INIT_FAIL = 'PKGSTDITEMTXT_INIT_FAIL'
export const PKGSTDITEMTXT_COMMIT_KEY = 'PKGSTDITEMTXT_COMMIT_KEY'
export const PKGSTDSUBITEMTXT_INIT_LOADING = 'PKGSTDSUBITEMTXT_INIT_LOADING'
export const PKGSTDSUBITEMTXT_INIT_SUCCESS = 'PKGSTDSUBITEMTXT_INIT_SUCCESS'
export const PKGSTDSUBITEMTXT_INIT_FAIL = 'PKGSTDSUBITEMTXT_INIT_FAIL'
export const PKGSTDSUBITEMTXT_COMMIT_KEY = 'PKGSTDSUBITEMTXT_COMMIT_KEY'
export const SCHEMECLAUSE_INIT_LOADING = 'SCHEMECLAUSE_INIT_LOADING'
export const SCHEMECLAUSE_INIT_SUCCESS = 'SCHEMECLAUSE_INIT_SUCCESS'
export const SCHEMECLAUSE_INIT_FAIL = 'SCHEMECLAUSE_INIT_FAIL'
export const SCHEMECLAUSE_COMMIT_KEY = 'SCHEMECLAUSE_COMMIT_KEY'

// Statistics Type and Value
export const STATSTYPE_INIT_LOADING = 'STATSTYPE_INIT_LOADING'
export const STATSTYPE_INIT_SUCCESS = 'STATSTYPE_INIT_SUCCESS'
export const STATSTYPE_INIT_FAIL = 'STATSTYPE_INIT_FAIL'

// Business Source
export const BUSSRC_INIT_LOADING = 'BUSSRC_INIT_LOADING'
export const BUSSRC_INIT_SUCCESS = 'BUSSRC_INIT_SUCCESS'
export const BUSSRC_INIT_FAIL = 'BUSSRC_INIT_FAIL'

// Bank
export const BANK_INIT_LOADING = 'BANK_INIT_LOADING'
export const BANK_INIT_SUCCESS = 'BANK_INIT_SUCCESS'
export const BANK_INIT_FAIL = 'BANK_INIT_FAIL'

// Policy Status
export const POLSTAT_INIT_LOADING = 'POLSTAT_INIT_LOADING'
export const POLSTAT_INIT_SUCCESS = 'POLSTAT_INIT_SUCCESS'
export const POLSTAT_INIT_FAIL = 'POLSTAT_INIT_FAIL'

// Account No. Suffix
export const ACCTNOSFX_INIT_LOADING = 'ACCTNOSFX_INIT_LOADING'
export const ACCTNOSFX_INIT_SUCCESS = 'ACCTNOSFX_INIT_SUCCESS'
export const ACCTNOSFX_INIT_FAIL = 'ACCTNOSFX_INIT_FAIL'

// GST
export const GST_INIT_LOADING = 'GST_INIT_LOADING'
export const GST_INIT_SUCCESS = 'GST_INIT_SUCCESS'
export const GST_INIT_FAIL = 'GST_INIT_FAIL'
export const GSTMAP_COMMIT_KEY = 'GSTMAP_COMMIT_KEY'

// Marime Parameters
export const MARINEPARAM_INIT_LOADING = 'MARINEPARAM_INIT_LOADING'
export const MARINEPARAM_INIT_SUCCESS = 'MARINEPARAM_INIT_SUCCESS'
export const MARINEPARAM_INIT_FAIL = 'MARINEPARAM_INIT_FAIL'

// Reports
export const REPORTS_INIT_LOADING = 'REPORTS_INIT_LOADING'
export const REPORTS_INIT_SUCCESS = 'REPORTS_INIT_SUCCESS'
export const REPORTS_INIT_FAIL = 'REPORTS_INIT_FAIL'
export const REPORTS_AGENCY_INIT_LOADING = 'REPORTS_AGENCY_INIT_LOADING'
export const REPORTS_AGENCY_INIT_SUCCESS = 'REPORTS_AGENCY_INIT_SUCCESS'
export const REPORTS_AGENCY_INIT_FAIL = 'REPORTS_AGENCY_INIT_FAIL'
export const REPORTS_HISTORY_INIT_LOADING = 'REPORTS_HISTORY_INIT_LOADING'
export const REPORTS_HISTORY_INIT_SUCCESS = 'REPORTS_HISTORY_INIT_SUCCESS'
export const REPORTS_HISTORY_INIT_FAIL = 'REPORTS_HISTORY_INIT_FAIL'
export const REPORTS_HISTORY_FAVOURITE_INIT_LOADING = 'REPORTS_HISTORY_FAVOURITE_INIT_LOADING'
export const REPORTS_HISTORY_FAVOURITE_INIT_SUCCESS = 'REPORTS_HISTORY_FAVOURITE_INIT_SUCCESS'
export const REPORTS_HISTORY_FAVOURITE_INIT_FAIL = 'REPORTS_HISTORY_FAVOURITE_INIT_FAIL'
export const REPORTS_HISTORY_LOADMORE_LOADING = 'REPORTS_HISTORY_LOADMORE_LOADING'
export const REPORTS_HISTORY_LOADMORE_SUCCESS = 'REPORTS_HISTORY_LOADMORE_SUCCESS'
export const REPORTS_HISTORY_LOADMORE_FAIL = 'REPORTS_HISTORY_LOADMORE_FAIL'
export const REPORTS_HISTORY_UPDATE = 'REPORTS_HISTORY_UPDATE'
export const REPORTS_HISTORY_FAVOURITE_UPDATE = 'REPORTS_HISTORY_FAVOURITE_UPDATE'
export const REPORTS_UW_INIT_LOADING = 'REPORTS_UW_INIT_LOADING'
export const REPORTS_UW_INIT_SUCCESS = 'REPORTS_UW_INIT_SUCCESS'
export const REPORTS_UW_INIT_FAIL = 'REPORTS_UW_INIT_FAIL'
export const REPORTS_RI_INIT_LOADING = 'REPORTS_RI_INIT_LOADING'
export const REPORTS_RI_INIT_SUCCESS = 'REPORTS_RI_INIT_SUCCESS'
export const REPORTS_RI_INIT_FAIL = 'REPORTS_RI_INIT_FAIL'
export const REPORTS_FIRESCHEDULE_INIT_LOADING = 'REPORTS_FIRESCHEDULE_INIT_LOADING'
export const REPORTS_FIRESCHEDULE_INIT_SUCCESS = 'REPORTS_FIRESCHEDULE_INIT_SUCCESS'
export const REPORTS_FIRESCHEDULE_INIT_FAIL = 'REPORTS_FIRESCHEDULE_INIT_FAIL'
export const REPORTS_CLAIM_INIT_LOADING = 'REPORTS_CLAIM_INIT_LOADING'
export const REPORTS_CLAIM_INIT_SUCCESS = 'REPORTS_CLAIM_INIT_SUCCESS'
export const REPORTS_CLAIM_INIT_FAIL = 'REPORTS_CLAIM_INIT_FAIL'
export const REPORTS_ACCT_INIT_LOADING = 'REPORTS_ACCT_INIT_LOADING'
export const REPORTS_ACCT_INIT_SUCCESS = 'REPORTS_ACCT_INIT_SUCCESS'
export const REPORTS_ACCT_INIT_FAIL = 'REPORTS_ACCT_INIT_FAIL'
export const DOC_ACCT_INIT_LOADING = 'DOC_ACCT_INIT_LOADING'
export const DOC_ACCT_INIT_SUCCESS = 'DOC_ACCT_INIT_SUCCESS'
export const DOC_ACCT_INIT_FAIL = 'DOC_ACCT_INIT_FAIL'
export const REPORTS_PARAM_INIT_LOADING = 'REPORTS_PARAM_INIT_LOADING'
export const REPORTS_PARAM_INIT_SUCCESS = 'REPORTS_PARAM_INIT_SUCCESS'
export const REPORTS_PARAM_INIT_FAIL = 'REPORTS_PARAM_INIT_FAIL'
export const REPORTS_SPECIAL_INIT_LOADING = 'REPORTS_SPECIAL_INIT_LOADING'
export const REPORTS_SPECIAL_INIT_SUCCESS = 'REPORTS_SPECIAL_INIT_SUCCESS'
export const REPORTS_SPECIAL_INIT_FAIL = 'REPORTS_SPECIAL_INIT_FAIL'
export const REPORTS_CUSTOM_1_INIT_LOADING = 'REPORTS_CUSTOM_1_INIT_LOADING'
export const REPORTS_CUSTOM_1_INIT_SUCCESS = 'REPORTS_CUSTOM_1_INIT_SUCCESS'
export const REPORTS_CUSTOM_1_INIT_FAIL = 'REPORTS_CUSTOM_1_INIT_FAIL'
export const REPORTS_CUSTOM_2_INIT_LOADING = 'REPORTS_CUSTOM_2_INIT_LOADING'
export const REPORTS_CUSTOM_2_INIT_SUCCESS = 'REPORTS_CUSTOM_2_INIT_SUCCESS'
export const REPORTS_CUSTOM_2_INIT_FAIL = 'REPORTS_CUSTOM_2_INIT_FAIL'
export const REPORTS_TREATY_INIT_LOADING = 'REPORTS_TREATY_INIT_LOADING'
export const REPORTS_TREATY_INIT_SUCCESS = 'REPORTS_TREATY_INIT_SUCCESS'
export const REPORTS_TREATY_INIT_FAIL = 'REPORTS_TREATY_INIT_FAIL'
export const REPORTS_EXTRA_INIT_LOADING = 'REPORTS_EXTRA_INIT_LOADING'
export const REPORTS_EXTRA_INIT_SUCCESS = 'REPORTS_EXTRA_INIT_SUCCESS'
export const REPORTS_EXTRA_INIT_FAIL = 'REPORTS_EXTRA_INIT_FAIL'

// Accounts
export const ACCOUNTS_INIT_LOADING = 'ACCOUNTS_INIT_LOADING'
export const ACCOUNTS_INIT_SUCCESS = 'ACCOUNTS_INIT_SUCCESS'
export const ACCOUNTS_INIT_FAIL = 'ACCOUNTS_INIT_FAIL'
export const ACCOUNTS_DETAILS_INIT = 'ACCOUNTS_DETAILS_INIT'
export const ACCOUNTS_DETAILS_SUCCESS = 'ACCOUNTS_DETAILS_SUCCESS'
export const ACCOUNTS_DETAILS_FAIL = 'ACCOUNTS_DETAILS_FAIL'
export const ACCOUNTS_LOAD_DATA = 'ACCOUNTS_LOAD_DATA'

// Receipts
export const RECEIPT_INIT_LOADING = 'RECEIPT_INIT_LOADING'
export const RECEIPT_INIT_SUCCESS = 'RECEIPT_INIT_SUCCESS'
export const RECEIPT_INIT_FAIL = 'RECEIPT_INIT_FAIL'
export const RECEIPT_LOAD_DATA = 'RECEIPT_LOAD_DATA'

// GLTRAN
export const GLTRAN_DETAIL = 'GLTRAN_DETAIL'

// Credit Note
export const CREDITNOTE_INIT_LOADING = 'CREDITNOTE_INIT_LOADING'
export const CREDITNOTE_INIT_SUCCESS = 'CREDITNOTE_INIT_SUCCESS'
export const CREDITNOTE_INIT_FAIL = 'CREDITNOTE_INIT_FAIL'
export const CREDITNOTE_LOAD_DATA = 'CREDITNOTE_LOAD_DATA'

// Document Format
export const DOCFORMAT_INIT_LOADING = 'DOCFORMAT_INIT_LOADING'
export const DOCFORMAT_INIT_SUCCESS = 'DOCFORMAT_INIT_SUCCESS'
export const DOCFORMAT_INIT_FAIL = 'DOCFORMAT_INIT_FAIL'
export const DOCFORMAT_DEFTEXT_LOADING = 'DOCFORMAT_DEFTEXT_LOADING'
export const DOCFORMAT_DEFTEXT_SUCCESS = 'DOCFORMAT_DEFTEXT_SUCCESS'
export const DOCFORMAT_DEFTEXT_FAIL = 'DOCFORMAT_DEFTEXT_FAIL'
export const CLAUSE_INIT_LOADING = 'CLAUSE_INIT_LOADING'
export const CLAUSE_INIT_SUCCESS = 'CLAUSE_INIT_SUCCESS'
export const CLAUSE_INIT_FAIL = 'CLAUSE_INIT_FAIL'

// Debit Note
export const DEBITNOTE_INIT_LOADING = 'DEBITNOTE_INIT_LOADING'
export const DEBITNOTE_INIT_SUCCESS = 'DEBITNOTE_INIT_SUCCESS'
export const DEBITNOTE_INIT_FAIL = 'DEBITNOTE_INIT_FAIL'
export const DEBITNOTE_LOAD_DATA = 'DEBITNOTE_LOAD_DATA'

// COMMON METHODS
export const COMMONS_INIT_LOADING = 'COMMONS_INIT_LOADING'
export const COMMONS_INIT_SUCCESS = 'COMMONS_INIT_SUCCESS'
export const COMMONS_INIT_FAIL = 'COMMONS_INIT_FAIL'

// PAYMENT
export const PAYMENT_INIT_LOADING = 'PAYMENT_INIT_LOADING'
export const PAYMENT_INIT_SUCCESS = 'PAYMENT_INIT_SUCCESS'
export const PAYMENT_INIT_FAIL = 'PAYMENT_INIT_FAIL'
export const PAYMENT_LOAD_DATA = 'PAYMENT_LOAD_DATA'

// DEFAULT BRANCH
export const USER_DEFAULT_BRANCH = 'USER_DEFAULT_BRANCH'

// RI AUTOCESSION
export const RI_AUTOCESSION_INIT_LOADING = 'RI_AUTOCESSION_INIT_LOADING'
export const RI_AUTOCESSION_INIT_SUCCESS = 'RI_AUTOCESSION_INIT_SUCCESS'
export const RI_AUTOCESSION_INIT_FAIL = 'RI_AUTOCESSION_INIT_FAIL'

// STANDARD RISK TEXT
export const STANDARD_RISK_TEXT_PARAM_INIT_LOADING = 'STANDARD_RISK_TEXT_PARAM_INIT_LOADING'
export const STANDARD_RISK_TEXT_PARAM_INIT_SUCCESS = 'STANDARD_RISK_TEXT_PARAM_INIT_SUCCESS'
export const STANDARD_RISK_TEXT_PARAM_INIT_FAIL = 'STANDARD_RISK_TEXT_PARAM_INIT_FAIL'

// STANDARD ITEM TEXT
export const STANDARD_ITEM_TEXT_PARAM_INIT_LOADING = 'STANDARD_ITEM_TEXT_PARAM_INIT_LOADING'
export const STANDARD_ITEM_TEXT_PARAM_INIT_SUCCESS = 'STANDARD_ITEM_TEXT_PARAM_INIT_SUCCESS'
export const STANDARD_ITEM_TEXT_PARAM_INIT_FAIL = 'STANDARD_ITEM_TEXT_PARAM_INIT_FAIL'

// STANDARD ITEM TEXT DEFAULT BENEFIT
export const STD_ITEM_TXT_DEF_BEN_INIT_LOADING = 'STD_ITEM_TXT_DEF_BEN_INIT_LOADING'
export const STD_ITEM_TXT_DEF_BEN_INIT_SUCCESS = 'STD_ITEM_TXT_DEF_BEN_INIT_SUCCESS'
export const STD_ITEM_TXT_DEF_BEN_INIT_FAIL = 'STD_ITEM_TXT_DEF_BEN_INIT_FAIL'
export const STD_ITEM_TXT_DEF_BEN_COMMIT_KEY = 'STD_ITEM_TXT_DEF_BEN_COMMIT_KEY'

// COVER
export const COVER_INIT_LOADING = 'COVER_INIT_LOADING'
export const COVER_INIT_SUCCESS = 'COVER_INIT_SUCCESS'
export const COVER_INIT_FAIL = 'COVER_INIT_FAIL'

// UNDERWRITING PRODUCT PARAMETER - MOTOR
export const UWMOTOR_INIT_LOADING = 'UWMOTOR_INIT_LOADING'
export const UWMOTOR_INIT_SUCCESS = 'UWMOTOR_INIT_SUCCESS'
export const UWMOTOR_INIT_FAIL = 'UWMOTOR_INIT_FAIL'
export const MTRNCD_INIT_LOADING = 'MTRNCD_INIT_LOADING'
export const MTRNCD_INIT_SUCCESS = 'MTRNCD_INIT_SUCCESS'
export const MTRNCD_INIT_FAIL = 'MTRNCD_INIT_FAIL'
export const UWMOTOR_LOAD_PERMITSTATUSLIST = 'UWMOTOR_LOAD_PERMITSTATUSLIST'
export const UWMOTOR_LOAD_BODYTYPELIST = 'UWMOTOR_LOAD_BODYTYPELIST'
export const UWMOTOR_LOAD_MAKELIST = 'UWMOTOR_LOAD_MAKELIST'
export const UWMOTOR_LOAD_GROUPLIST = 'UWMOTOR_LOAD_GROUPLIST'

// DISCOUNT / LOADING TYPE -- UNDERWRITTING PARAMETERS
export const DISCOUNT_LOADING_PARAM_INIT_LOADING = 'DISCOUNT_LOADING_PARAM_INIT_LOADING'
export const DISCOUNT_LOADING_PARAM_INIT_SUCCESS = 'DISCOUNT_LOADING_PARAM_INIT_SUCCESS'
export const DISCOUNT_LOADING_PARAM_INIT_FAIL = 'DISCOUNT_LOADING_PARAM_INIT_FAIL'

// ACCUMULATION TYPE -- REINSURANCE PARAMETERS
export const ACCUMULATION_TYPE_PARAM_INIT_LOADING = 'ACCUMULATION_TYPE_PARAM_INIT_LOADING'
export const ACCUMULATION_TYPE_PARAM_INIT_SUCCESS = 'ACCUMULATION_TYPE_PARAM_INIT_SUCCESS'
export const ACCUMULATION_TYPE_PARAM_INIT_FAIL = 'ACCUMULATION_TYPE_PARAM_INIT_FAIL'

// MATCH TRANSACTION
export const MATCH_INIT_LOADING = 'MATCH_INIT_LOADING'
export const MATCH_INIT_SUCCESS = 'MATCH_INIT_SUCCESS'
export const MATCH_INIT_FAIL = 'MATCH_INIT_FAIL'
export const MATCH_LOAD_DATA = 'MATCH_LOAD_DATA'
export const MATCH_LOAD_LISTING = 'MATCH_LOAD_LISTING'
export const MATCH_DATA_EDIT = 'MATCH_DATA_EDIT'

// NON TRADE
export const NON_TRADE_INIT_LOADING = 'NON_TRADE_INIT_LOADING'
export const NON_TRADE_INIT_SUCCESS = 'NON_TRADE_INIT_SUCCESS'
export const NON_TRADE_INIT_FAIL = 'NON_TRADE_INIT_FAIL'
export const NON_TRADE_LOAD_DATA = 'NON_TRADE_LOAD_DATA'

// TREATY PARAMETERS -- REINSURANCE PARAMETERS
export const TREATY_PARAMETERS_PARAM_INIT_LOADING = 'TREATY_PARAMETERS_PARAM_INIT_LOADING'
export const TREATY_PARAMETERS_PARAM_INIT_SUCCESS = 'TREATY_PARAMETERS_PARAM_INIT_SUCCESS'
export const TREATY_PARAMETERS_PARAM_INIT_FAIL = 'TREATY_PARAMETERS_PARAM_INIT_FAIL'

// TREATY ACCOUNT PARAMETERS - MAIN BUSINESS CLASS PARAMETERS
export const TREATY_ACCOUNT_PARAM_INIT_LOADING = 'TREATY_ACCOUNT_PARAM_INIT_LOADING'
export const TREATY_ACCOUNT_PARAM_INIT_SUCCESS = 'TREATY_ACCOUNT_PARAM_INIT_SUCCESS'
export const TREATY_ACCOUNT_PARAM_INIT_FAIL = 'TREATY_ACCOUNT_PARAM_INIT_FAIL'
export const MAINBUSCLS_PARAM_INIT_LOADING = 'MAINBUSCLS_PARAM_INIT_LOADING'
export const MAINBUSCLS_PARAM_INIT_SUCCESS = 'MAINBUSCLS_PARAM_INIT_SUCCESS'
export const MAINBUSCLS_PARAM_INIT_FAIL = 'MAINBUSCLS_PARAM_INIT_FAIL'

// BLKPARAM
export const BLKPARAM_INIT_LOADING = 'BLKPARAM_INIT_LOADING'
export const BLKPARAM_INIT_SUCCESS = 'BLKPARAM_INIT_SUCCESS'
export const BLKPARAM_INIT_FAIL = 'BLKPARAM_INIT_FAIL'

// CLAIMS PARAMETERS -- PERMITTED CLAIMS RESERVE CATEGORY PER BUSINESS CLASS
export const PMT_CLM_RES_CAT_PER_BUS_CLS_INIT_LOADING = 'PMT_CLM_RES_CAT_PER_BUS_CLS_INIT_LOADING'
export const PMT_CLM_RES_CAT_PER_BUS_CLS_INIT_SUCCESS = 'PMT_CLM_RES_CAT_PER_BUS_CLS_INIT_SUCCESS'
export const PMT_CLM_RES_CAT_PER_BUS_CLS_INIT_FAIL = 'PMT_CLM_RES_CAT_PER_BUS_CLS_INIT_FAIL'

// CLAIMS PARAMETER -- PERMITTED NOL 1 PER BUSINESS CLASS
export const PMT_NOL_1_PER_BUS_CLS_INIT_LOADING = 'PMT_NOL_1_PER_BUS_CLS_INIT_LOADING'
export const PMT_NOL_1_PER_BUS_CLS_INIT_SUCCESS = 'PMT_NOL_1_PER_BUS_CLS_INIT_SUCCESS'
export const PMT_NOL_1_PER_BUS_CLS_INIT_FAIL = 'PMT_NOL_1_PER_BUS_CLS_INIT_FAIL'

// CLAIMS PARAMETER -- CLAIMS RESERVE CATEGORY
export const CLM_RES_CAT_INIT_LOADING = 'CLM_RES_CAT_INIT_LOADING'
export const CLM_RES_CAT_INIT_SUCCESS = 'CLM_RES_CAT_INIT_SUCCESS'
export const CLM_RES_CAT_INIT_FAIL = 'CLM_RES_CAT_INIT_FAIL'

// CLAIMS PARAMETER -- CLAIMS PAYMENT TYPE
export const CLM_PAYT_TYPE_INIT_LOADING = 'CLM_PAYT_TYPE_INIT_LOADING'
export const CLM_PAYT_TYPE_INIT_SUCCESS = 'CLM_PAYT_TYPE_INIT_SUCCESS'
export const CLM_PAYT_TYPE_INIT_FAIL = 'CLM_PAYT_TYPE_INIT_FAIL'

// CLAIMS PARAMETER -- CLAIMS NATURE OF LOSS 1
export const CLM_NOL_1_INIT_LOADING = 'CLM_NOL_1_INIT_LOADING'
export const CLM_NOL_1_INIT_SUCCESS = 'CLM_NOL_1_INIT_SUCCESS'
export const CLM_NOL_1_INIT_FAIL = 'CLM_NOL_1_INIT_FAIL'

// CLAIMS PARAMETER -- CLAIMS NATURE OF LOSS 2
export const CLM_NOL_2_INIT_LOADING = 'CLM_NOL_2_INIT_LOADING'
export const CLM_NOL_2_INIT_SUCCESS = 'CLM_NOL_2_INIT_SUCCESS'
export const CLM_NOL_2_INIT_FAIL = 'CLM_NOL_2_INIT_FAIL'

// GLOBAL PARAMETER -- DOCUMENT HEADING TEXT
export const DOC_HDG_TXT_INIT_LOADING = 'DOC_HDG_TXT_INIT_LOADING'
export const DOC_HDG_TXT_INIT_SUCCESS = 'DOC_HDG_TXT_INIT_SUCCESS'
export const DOC_HDG_TXT_INIT_FAIL = 'DOC_HDG_TXT_INIT_FAIL'

//  CLAIM PARAMETER -- CLAIM STATUS
export const CLAIMSTATUS_INIT_LOADING = 'CLAIMSTATUS_INIT_LOADING'
export const CLAIMSTATUS_INIT_SUCCESS = 'CLAIMSTATUS_INIT_SUCCESS'
export const CLAIMSTATUS_INIT_FAIL = 'CLAIMSTATUS_INIT_FAIL'
export const CLAIMSTATUS_COMMIT_KEY = 'CLAIMSTATUS_COMMIT_KEY'

// REINSURANCE PARAMETER -- Co/RI Panel
export const CO_RI_PANEL_INIT_LOADING = 'CO_RI_PANEL_INIT_LOADING'
export const CO_RI_PANEL_INIT_SUCCESS = 'CO_RI_PANEL_INIT_SUCCESS'
export const CO_RI_PANEL_INIT_FAIL = 'CO_RI_PANEL_INIT_FAIL'

//  CLAIM PARAMETER -- CLAIM STATUS CAUSE
export const CLAIMSTATUSCAUSE_INIT_LOADING = 'CLAIMSTATUSCAUSE_INIT_LOADING'
export const CLAIMSTATUSCAUSE_INIT_SUCCESS = 'CLAIMSTATUSCAUSE_INIT_SUCCESS'
export const CLAIMSTATUSCAUSE_INIT_FAIL = 'CLAIMSTATUSCAUSE_INIT_FAIL'

// REINSURANCE PARAMETER -- RETENTION LIMIT
export const RTN_LIM_INIT_LOADING = 'RTN_LIM_INT_LOADING'
export const RTN_LIM_INIT_SUCCESS = 'RTN_LIM_INT_SUCCESS'
export const RTN_LIM_INIT_FAIL = 'RTN_LIM_INT_FAIL'

//  PERMITTED PER SCHEME PER INTERMEDIARY
export const INTERSCHEME_INIT_LOADING = 'INTERSCHEME_INIT_LOADING'
export const INTERSCHEME_INIT_SUCCESS = 'INTERSCHEME_INIT_SUCCESS'
export const INTERSCHEME_INIT_FAIL = 'INTERSCHEME_INIT_FAIL'
export const INTERSCHEME_COMMIT_KEY = 'INTERSCHEME_COMMIT_KEY'

//  SHORT TERM RATE
export const SHORTTERMRATE_INIT_LOADING = 'SHORTTERMRATE_INIT_LOADING'
export const SHORTTERMRATE_INIT_SUCCESS = 'SHORTTERMRATE_INIT_SUCCESS'
export const SHORTTERMRATE_INIT_FAIL = 'SHORTTERMRATE_INIT_FAIL'
export const SHORTTERMRATE_COMMIT_KEY = 'SHORTTERMRATE_COMMIT_KEY'

//  TREATY LIMIT
export const TREATYLIMIT_INIT_LOADING = 'TREATYLIMIT_INIT_LOADING'
export const TREATYLIMIT_INIT_SUCCESS = 'TREATYLIMIT_INIT_SUCCESS'
export const TREATYLIMIT_INIT_FAIL = 'TREATYLIMIT_INIT_FAIL'
export const TREATYLIMIT_COMMIT_KEY = 'TREATYLIMIT_COMMIT_KEY'

//  JOURNAL
export const JOURNAL_INIT_LOADING = 'JOURNAL_INIT_LOADING'
export const JOURNAL_INIT_SUCCESS = 'JOURNAL_INIT_SUCCESS'
export const JOURNAL_INIT_FAIL = 'JOURNAL_INIT_FAIL'
export const JOURNAL_COMMIT_KEY = 'JOURNAL_COMMIT_KEY'

// Permitted Benefit Per Business Class
export const PMT_BENEFIT_PER_BUS_CLS_INIT_LOADING = 'PMT_BENEFIT_PER_BUS_CLS_INIT_LOADING'
export const PMT_BENEFIT_PER_BUS_CLS_INIT_SUCCESS = 'PMT_BENEFIT_PER_BUS_CLS_INIT_SUCCESS'
export const PMT_BENEFIT_PER_BUS_CLS_INIT_FAIL = 'PMT_BENEFIT_PER_BUS_CLS_INIT_FAIL'

// Permitted Tariff Per Business Class
export const PMT_TARIFF_PER_BUS_CLS_INIT_LOADING = 'PMT_TARIFF_PER_BUS_CLS_INIT_LOADING'
export const PMT_TARIFF_PER_BUS_CLS_INIT_SUCCESS = 'PMT_TARIFF_PER_BUS_CLS_INIT_SUCCESS'
export const PMT_TARIFF_PER_BUS_CLS_INIT_FAIL = 'PMT_TARIFF_PER_BUS_CLS_INIT_FAIL'

// Tariff Benefits
export const TARIFF_BENEFITS_INIT_LOADING = 'TARIFF_BENEFITS_INIT_LOADING'
export const TARIFF_BENEFITS_INIT_SUCCESS = 'TARIFF_BENEFITS_INIT_SUCCESS'
export const TARIFF_BENEFITS_INIT_FAIL = 'TARIFF_BENEFITS_INIT_FAIL'

// Tariff Factor
export const TARIFF_FACTOR_INIT_LOADING = 'TARIFF_FACTOR_INIT_LOADING'
export const TARIFF_FACTOR_INIT_SUCCESS = 'TARIFF_FACTOR_INIT_SUCCESS'
export const TARIFF_FACTOR_INIT_FAIL = 'TARIFF_FACTOR_INIT_FAIL'
export const TARIFF_FACTOR_COMMIT_KEY = 'TARIFF_FACTOR_COMMIT_KEY'

// Risk Factor
export const RISK_FACTOR_INIT_LOADING = 'RISK_FACTOR_INIT_LOADING'
export const RISK_FACTOR_INIT_SUCCESS = 'RISK_FACTOR_INIT_SUCCESS'
export const RISK_FACTOR_INIT_FAIL = 'RISK_FACTOR_INIT_FAIL'
export const RISK_FACTOR_COMMIT_KEY = 'RISK_FACTOR_COMMIT_KEY'

// Tariff Rate
export const TARIFF_RATE_INIT_LOADING = 'TARIFF_RATE_INIT_LOADING'
export const TARIFF_RATE_INIT_SUCCESS = 'TARIFF_RATE_INIT_SUCCESS'
export const TARIFF_RATE_INIT_FAIL = 'TARIFF_RATE_INIT_FAIL'
export const TARIFF_RATE_COMMIT_KEY = 'TARIFF_RATE_COMMIT_KEY'

// Tariff Premium
export const TARIFF_PREM_INIT_LOADING = 'TARIFF_PREM_INIT_LOADING'
export const TARIFF_PREM_INIT_SUCCESS = 'TARIFF_PREM_INIT_SUCCESS'
export const TARIFF_PREM_INIT_FAIL = 'TARIFF_PREM_INIT_FAIL'
export const TARIFF_PREM_COMMIT_KEY = 'TARIFF_PREM_COMMIT_KEY'

// Fund
export const FIREPARAM_INIT_LOADING = 'FIREPARAM_INIT_LOADING'
export const FIREPARAM_INIT_SUCCESS = 'FIREPARAM_INIT_SUCCESS'
export const FIREPARAM_INIT_FAIL = 'FIREPARAM_INIT_FAIL'

// Claims
export const CLAIMS_INIT_LOADING = 'CLAIMS_INIT_LOADING'
export const CLAIMS_INIT_SUCCESS = 'CLAIMS_INIT_SUCCESS'
export const CLAIMS_INIT_FAIL = 'CLAIMS_INIT_FAIL'
export const CLAIMS_CLAIMENTRY_INIT_LOADING = 'CLAIMS_CLAIMENTRY_INIT_LOADING'
export const CLAIMS_CLAIMENTRY_INIT_SUCCESS = 'CLAIMS_CLAIMENTRY_INIT_SUCCESS'
export const CLAIMS_CLAIMENTRY_INIT_FAIL = 'CLAIMS_CLAIMENTRY_INIT_FAIL'
export const CLAIMS_CLAIMDETAIL_RESET = 'CLAIMS_CLAIMDETAIL_RESET'
export const CLAIMS_CLAIMDETAIL_INIT_LOADING = 'CLAIMS_CLAIMDETAIL_INIT_LOADING'
export const CLAIMS_CLAIMDETAIL_INIT_SUCCESS = 'CLAIMS_CLAIMDETAIL_INIT_SUCCESS'
export const CLAIMS_CLAIMDETAIL_INIT_FAIL = 'CLAIMS_CLAIMDETAIL_INIT_FAIL'
export const CLAIMS_CLAIMDETAIL_SAVE_LOADING = 'CLAIMS_CLAIMDETAIL_SAVE_LOADING'
export const CLAIMS_CLAIMDETAIL_SAVE_SUCCESS = 'CLAIMS_CLAIMDETAIL_SAVE_SUCCESS'
export const CLAIMS_CLAIMDETAIL_SAVE_FAIL = 'CLAIMS_CLAIMDETAIL_SAVE_FAIL'
export const CLAIMS_CLAIMDETAIL_LOAD_DATA = 'CLAIMS_CLAIMDETAIL_LOAD_DATA'
export const CLAIMS_CLAIMDETAIL_LEAVEQUOTE = 'CLAIMS_CLAIMDETAIL_LEAVEQUOTE'
export const CLAIMS_CLAIMDETAIL_CLAIMANT = 'CLAIMS_CLAIMDETAIL_CLAIMANT'
export const CLAIMS_CLAIMDETAIL_CLAIMITEM = 'CLAIMS_CLAIMDETAIL_CLAIMITEM'
export const CLAIMS_LISTING_INIT_LOADING = 'CLAIMS_LISTING_INIT_LOADING'
export const CLAIMS_LISTING_INIT_SUCCESS = 'CLAIMS_LISTING_INIT_SUCCESS'
export const CLAIMS_LISTING_INIT_FAIL = 'CLAIMS_LISTING_INIT_FAIL'
export const CLAIMS_CLAIMDETAIL_PARAM = 'CLAIMS_CLAIMDETAIL_PARAM'
export const CLAIMS_CLAIMDETAIL_PARAM_NOL1 = 'CLAIMS_CLAIMDETAIL_PARAM_NOL1'
export const CLAIMS_CLAIMDETAIL_PARAM_RESERVE_LOADING = 'CLAIMS_CLAIMDETAIL_PARAM_RESERVE_LOADING'
export const CLAIMS_CLAIMDETAIL_PARAM_RESERVE = 'CLAIMS_CLAIMDETAIL_PARAM_RESERVE'
export const CLAIMS_CLAIMDETAIL_PARAM_RESERVE_FAIL = 'CLAIMS_CLAIMDETAIL_PARAM_RESERVE_FAIL'
export const CLAIMS_CLAIMDETAIL_RESERVE = 'CLAIMS_CLAIMDETAIL_RESERVE'
export const CLAIMS_CLAIMDETAIL_CLAIMRESERVE = 'CLAIMS_CLAIMDETAIL_CLAIMRESERVE'
export const CLAIMS_CLAIMDETAIL_LEAVECLAIM = 'CLAIMS_CLAIMDETAIL_LEAVECLAIM'
export const CLAIMS_UPDATESTATUS_INIT_LOADING = 'CLAIMS_UPDATESTATUS_INIT_LOADING'
export const CLAIMS_UPDATESTATUS_INIT_SUCCESS = 'CLAIMS_UPDATESTATUS_INIT_SUCCESS'
export const CLAIMS_UPDATESTATUS_INIT_FAIL = 'CLAIMS_UPDATESTATUS_INIT_FAIL'
export const CLAIMS_POSTING_INIT_LOADING = 'CLAIMS_POSTING_INIT_LOADING'
export const CLAIMS_POSTING_INIT_SUCCESS = 'CLAIMS_POSTING_INIT_SUCCESS'
export const CLAIMS_POSTING_INIT_FAIL = 'CLAIMS_POSTING_INIT_FAIL'
export const CLAIMS_STAGING_INIT_LOADING = 'CLAIMS_STAGING_INIT_LOADING'
export const CLAIMS_STAGING_INIT_SUCCESS = 'CLAIMS_STAGING_INIT_SUCCESS'
export const CLAIMS_STAGING_INIT_FAIL = 'CLAIMS_STAGING_INIT_FAIL'
export const CLAIMS_PROCESS_NOTIF_SET = 'CLAIMS_PROCESS_NOTIF_SET'
export const CLAIMS_PROCESS_NOTIF_RESET = 'CLAIMS_PROCESS_NOTIF_RESET'
export const CLAIMS_PROCESS_NOTIF_FAIL = 'CLAIMS_PROCESS_NOTIF_FAIL'
export const CLAIMS_LOAD_BACK_LISTING = 'CLAIMS_LOAD_BACK_LISTING'
export const CLAIMS_TRANDATE_CHANGED = 'CLAIMS_TRANDATE_CHANGED'

// members
export const TABMENU = 'TABMENU'
export const MISCTAB = 'MISCTAB'
export const TRANSLINK = 'TRANSLINK'

// Parameters
export const PARAMETERS_INIT_LOADING = 'PARAMETERS_INIT_LOADING'
export const PARAMETERS_INIT_SUCCESS = 'PARAMETERS_INIT_SUCCESS'
export const PARAMETERS_INIT_FAIL = 'PARAMETERS_INIT_FAIL'
export const PARAMETERS_APPID = 'PARAMETERS_APPID'
export const PARAMETERS_TARIFFLIST = 'PARAMETERS_TARIFFLIST'
export const PARAMETERS_VEHGRPLIST = 'PARAMETERS_VEHGRPLIST'
export const PARAMETERS_COVERSLIST = 'PARAMETERS_COVERSLIST'
export const PARAMETERS_FACTORLIST = 'PARAMETERS_FACTORLIST'

// Duration
export const MISC_DURATION_INIT_LOADING = 'MISC_DURATION_INIT_LOADING'
export const MISC_DURATION_INIT_SUCCESS = 'MISC_DURATION_INIT_SUCCESS'
export const MISC_DURATION_INIT_FAIL = 'MISC_DURATION_INIT_FAIL'
export const MISC_DURATION_LIST = 'MISC_DURATION_LIST'

// ISO Country
export const MISC_INIT_LOADING = 'MISC_INIT_LOADING'
export const MISC_INIT_SUCCESS = 'MISC_INIT_SUCCESS'
export const MISC_INIT_FAIL = 'MISC_INIT_FAIL'
export const MISC_ISOCTYLIST = 'MISC_ISOCTYLIST'

// Vehicle
export const VEHICLE_INIT_LOADING = 'VEHICLE_INIT_LOADING'
export const VEHICLE_INIT_SUCCESS = 'VEHICLE_INIT_SUCCESS'
export const VEHICLE_INIT_FAIL = 'VEHICLE_INIT_FAIL'
export const VEHICLE_PERMITSTATUSLIST = 'VEHICLE_PERMITSTATUSLIST'
export const VEHICLE_BODYTYELIST = 'VEHICLE_BODYTYELIST'
export const VEHICLE_MAKELIST = 'VEHICLE_MAKELIST'
export const VEHICLE_GROUPLIST = 'VEHICLE_GROUPLIST'

// Vessel
export const VESSEL_INIT_LOADING = 'VESSEL_INIT_LOADING'
export const VESSEL_INIT_SUCCESS = 'VESSEL_INIT_SUCCESS'
export const VESSEL_INIT_FAIL = 'VESSEL_INIT_FAIL'
export const VESSEL_DETAILLIST = 'VESSEL_DETAILLIST'
export const VESSEL_CLASSLIST = 'VESSEL_CLASSLIST'
export const VESSEL_CONSTNLIST = 'VESSEL_CONSTNLIST'
export const VESSEL_ENGMAKELIST = 'VESSEL_ENGMAKELIST'
export const VESSEL_ENGMODLIST = 'VESSEL_ENGMODLIST'
export const VESSEL_FLAGLIST = 'VESSEL_FLAGLIST'
export const VESSEL_TYPELIST = 'VESSEL_TYPELIST'

export const VESSEL_SIDEMENU = 'VESSEL_SIDEMENU'
export const VESSEL_VOYAGE_TABMENU = 'VESSEL_VOYAGE_TABMENU'

// Cargo
export const CARGO_INIT_LOADING = 'CARGO_INIT_LOADING'
export const CARGO_INIT_SUCCESS = 'CARGO_INIT_SUCCESS'
export const CARGO_INIT_FAIL = 'CARGO_INIT_FAIL'

// Statistics
export const STATISTICS_INIT_LOADING = 'STATISTICS_INIT_LOADING'
export const STATISTICS_INIT_SUCCESS = 'STATISTICS_INIT_SUCCESS'
export const STATISTICS_INIT_FAIL = 'STATISTICS_INIT_FAIL'

// Coverage
export const COVERAGE_INIT_LOADING = 'COVERAGE_INIT_LOADING'
export const COVERAGE_INIT_SUCCESS = 'COVERAGE_INIT_SUCCESS'
export const COVERAGE_INIT_FAIL = 'COVERAGE_INIT_FAIL'
export const CLAUSELIST = 'CLAUSELIST'

// Benefit
export const BENEFIT_INIT_LOADING = 'BENEFIT_INIT_LOADING'
export const BENEFIT_INIT_SUCCESS = 'BENEFIT_INIT_SUCCESS'
export const BENEFIT_INIT_FAIL = 'BENEFIT_INIT_FAIL'

// Business Class
export const BUSCLS_INIT_LOADING = 'BUSCLS_INIT_LOADING'
export const BUSCLS_INIT_SUCCESS = 'BUSCLS_INIT_SUCCESS'
export const BUSCLS_INIT_FAIL = 'BUSCLS_INIT_FAIL'
export const BUSCLS_MENU_LOADING = 'BUSCLS_MENU_LOADING'
export const BUSCLS_MENU_SUCCESS = 'BUSCLS_MENU_SUCCESS'
export const BUSCLS_MENU_FAIL = 'BUSCLS_MENU_FAIL'
export const BUSCLS_TARF_LOADING = 'BUSCLS_TARF_LOADING'
export const BUSCLS_TARF_SUCCESS = 'BUSCLS_TARF_SUCCESS'
export const BUSCLS_TARF_FAIL = 'BUSCLS_TARF_FAIL'
export const BUSCLS_COVER_LOADING = 'BUSCLS_COVER_LOADING'
export const BUSCLS_COVER_SUCCESS = 'BUSCLS_COVER_SUCCESS'
export const BUSCLS_COVER_FAIL = 'BUSCLS_COVER_FAIL'
export const BUSCLS_INIT_LIST = 'BUSCLS_INIT_LIST'

// Business Class Tariff
export const TARF_INIT_LOADING = 'TARF_INIT_LOADING'
export const TARF_INIT_SUCCESS = 'TARF_INIT_SUCCESS'
export const TARF_INIT_FAIL = 'TARF_INIT_FAIL'
export const TARF_BENEFIT_LOADING = 'TARF_BENEFIT_LOADING'
export const TARF_BENEFIT_SUCCESS = 'TARF_BENEFIT_SUCCESS'
export const TARF_BENEFIT_FAIL = 'TARF_BENEFIT_FAIL'
export const TARF_FACTOR_LOADING = 'TARF_FACTOR_LOADING'
export const TARF_FACTOR_SUCCESS = 'TARF_FACTOR_SUCCESS'
export const TARF_FACTOR_FAIL = 'TARF_FACTOR_FAIL'

// Package
export const PKGPLAN_MENU_LOADING = 'PKGPLAN_MENU_LOADING'
export const PKGPLAN_MENU_SUCCESS = 'PKGPLAN_MENU_SUCCESS'
export const PKGPLAN_MENU_FAIL = 'PKGPLAN_MENU_FAIL'
export const PKGRISK_MENU_LOADING = 'PKGRISK_MENU_LOADING'
export const PKGRISK_MENU_SUCCESS = 'PKGRISK_MENU_SUCCESS'
export const PKGRISK_MENU_FAIL = 'PKGRISK_MENU_FAIL'
export const PKGRISKITEM_MENU_LOADING = 'PKGRISKITEM_MENU_LOADING'
export const PKGRISKITEM_MENU_SUCCESS = 'PKGRISKITEM_MENU_SUCCESS'
export const PKGRISKITEM_MENU_FAIL = 'PKGRISKITEM_MENU_FAIL'
export const STDRISKTEXT_MENU_LOADING = 'STDRISKTEXT_MENU_LOADING'
export const STDRISKTEXT_MENU_SUCCESS = 'STDRISKTEXT_MENU_SUCCESS'
export const STDRISKTEXT_MENU_FAIL = 'STDRISKTEXT_MENU_FAIL'
export const STDITEMTEXT_MENU_LOADING = 'STDITEMTEXT_MENU_LOADING'
export const STDITEMTEXT_MENU_SUCCESS = 'STDITEMTEXT_MENU_SUCCESS'
export const STDITEMTEXT_MENU_FAIL = 'STDITEMTEXT_MENU_FAIL'
export const PKGTARFBEN_MENU_LOADING = 'PKGTARFBEN_MENU_LOADING'
export const PKGTARFBEN_MENU_SUCCESS = 'PKGTARFBEN_MENU_SUCCESS'
export const PKGTARFBEN_MENU_FAIL = 'PKGTARFBEN_MENU_FAIL'
export const PKGTARFFACT_MENU_LOADING = 'PKGTARFFACT_MENU_LOADING'
export const PKGTARFFACT_MENU_SUCCESS = 'PKGTARFFACT_MENU_SUCCESS'
export const PKGTARFFACT_MENU_FAIL = 'PKGTARFFACT_MENU_FAIL'
export const STDRISKTEXT_SET = 'STDRISKTEXT_SET'
export const FACTORLIST_SET = 'FACTORLIST_SET'

// Standard Risk Text
export const STDRISK_INIT_LOADING = 'STDRISK_INIT_LOADING'
export const STDRISK_INIT_SUCCESS = 'STDRISK_INIT_SUCCESS'
export const STDRISK_INIT_FAIL = 'STDRISK_INIT_FAIL'
export const STDRISK_TEXT_INIT_LOADING = 'STDRISK_TEXT_INIT_LOADING'
export const STDRISK_TEXT_INIT_SUCCESS = 'STDRISK_TEXT_INIT_SUCCESS'
export const STDRISK_TEXT_INIT_FAIL = 'STDRISK_TEXT_INIT_FAIL'
export const STDRISK_ITEMTEXT_INIT_LOADING = 'STDRISK_ITEMTEXT_INIT_LOADING'
export const STDRISK_ITEMTEXT_INIT_SUCCESS = 'STDRISK_ITEMTEXT_INIT_SUCCESS'
export const STDRISK_ITEMTEXT_INIT_FAIL = 'STDRISK_ITEMTEXT_INIT_FAIL'

// Product
export const PRODUCT_MENU_INIT_LOADING = 'PRODUCT_MENU_INIT_LOADING'
export const PRODUCT_MENU_INIT_SUCCESS = 'PRODUCT_MENU_INIT_SUCCESS'
export const PRODUCT_MENU_INIT_FAIL = 'PRODUCT_MENU_INIT_FAIL'
export const PRODUCT_MENU_LOADING = 'PRODUCT_MENU_LOADING'
export const PRODUCT_MENU_SUCCESS = 'PRODUCT_MENU_SUCCESS'
export const PRODUCT_MENU_FAIL = 'PRODUCT_MENU_FAIL'

// Promotion Management
export const PROMOTION_MANAGEMENT_INIT_LOADING = 'PROMOTION_MANAGEMENT_INIT_LOADING'
export const PROMOTION_MANAGEMENT_INIT_SUCCESS = 'PROMOTION_MANAGEMENT_INIT_SUCCESS'
export const PROMOTION_MANAGEMENT_INIT_FAIL = 'PROMOTION_MANAGEMENT_INIT_FAIL'
export const CAMPAIGN_INIT_LOADING = 'CAMPAIGN_INIT_LOADING'
export const CAMPAIGN_INIT_SUCCESS = 'CAMPAIGN_INIT_SUCCESS'
export const CAMPAIGN_INIT_FAIL = 'CAMPAIGN_INIT_FAIL'
export const CAMPAIGN_SIDEMENU = 'CAMPAIGN_SIDEMENU'
export const PROMOTION_INIT_LOADING = 'PROMOTION_INIT_LOADING'
export const PROMOTION_INIT_SUCCESS = 'PROMOTION_INIT_SUCCESS'
export const PROMOTION_INIT_FAIL = 'PROMOTION_INIT_FAIL'
export const PROMOTION_SIDEMENU = 'PROMOTION_SIDEMENU'
export const PROMOTION_PROMOFACT = 'PROMOTION_PROMOFACT'
export const PROMOTION_PROMOFACT_TABMENU = 'PROMOTION_PROMOFACT_TABMENU'
export const PROMOTION_FACTORLIST = 'PROMOTION_FACTORLIST'

// Fire
export const FIRE_INIT_LOADING = 'FIRE_INIT_LOADING'
export const FIRE_INIT_SUCCESS = 'FIRE_INIT_SUCCESS'
export const FIRE_INIT_FAIL = 'FIRE_INIT_FAIL'

// Intermediary Comm Disc Factors
export const ADMININTERMEDIARY_INTERCOMMDISCFACT = 'ADMININTERMEDIARY_INTERCOMMDISCFACT'
export const ADMININTERMEDIARY_INTERCOMMDISCFACT_TABMENU = 'ADMININTERMEDIARY_INTERCOMMDISCFACT_TABMENU'
export const ADMININTERMEDIARY_INTERCOMMDISCFACTORLIST = 'ADMININTERMEDIARY_INTERCOMMDISCFACTORLIST'

// Currency
export const CURRENCY_INIT_LOADING = 'CURRENCY_INIT_LOADING'
export const CURRENCY_INIT_SUCCESS = 'CURRENCY_INIT_SUCCESS'
export const CURRENCY_INIT_FAIL = 'CURRENCY_INIT_FAIL'

// Standard Comm Disc Factors
export const PRODUCT_STDCOMMDISCFACT_TABMENU = 'PRODUCT_STDCOMMDISCFACT_TABMENU'
export const PRODUCT_STDCOMMDISCFACT = 'PRODUCT_STDCOMMDISCFACT'
export const PRODUCT_STDCOMMDISCFACTORLIST = 'PRODUCT_STDCOMMDISCFACTORLIST'

// Travel
export const TRAVEL_INIT_LOADING = 'TRAVEL_INIT_LOADING'
export const TRAVEL_INIT_SUCCESS = 'TRAVEL_INIT_SUCCESS'
export const TRAVEL_INIT_FAIL = 'TRAVEL_INIT_FAIL'

// Claim Param
export const CLAIMPARAM_INIT_LOADING = 'CLAIMPARAM_INIT_LOADING'
export const CLAIMPARAM_INIT_SUCCESS = 'CLAIMPARAM_INIT_SUCCESS'
export const CLAIMPARAM_INIT_FAIL = 'CLAIMPARAM_INIT_FAIL'

// Module General Settings
export const MODGENERAL_INIT_LOADING = 'MODGENERAL_INIT_LOADING'
export const MODGENERAL_INIT_SUCCESS = 'MODGENERAL_INIT_SUCCESS'
export const MODGENERAL_INIT_FAIL = 'MODGENERAL_INIT_FAIL'

// Underwritting Parameters - Campaign & Promotion - Campaign
export const PARAM_CAMPAIGN_INIT_LOADING = 'PARAM_CAMPAIGN_INIT_LOADING'
export const PARAM_CAMPAIGN_INIT_SUCCESS = 'PARAM_CAMPAIGN_INIT_SUCCESS'
export const PARAM_CAMPAIGN_INIT_FAIL = 'PARAM_CAMPAIGN_INIT_FAIL'

// Module Accounting Period
export const ACCTPERIODPARAM_INIT_LOADING = 'ACCTPERIODPARAM_INIT_LOADING'
export const ACCTPERIODPARAM_INIT_SUCCESS = 'ACCTPERIODPARAM_INIT_SUCCESS'
export const ACCTPERIODPARAM_INIT_FAIL = 'ACCTPERIODPARAM_INIT_FAIL'

// Module Marine Cargo Parameters
export const MARINECARGOPARAM_INIT_LOADING = 'MARINECARGOPARAM_INIT_LOADING'
export const MARINECARGOPARAM_INIT_SUCCESS = 'MARINECARGOPARAM_INIT_SUCCESS'
export const MARINECARGOPARAM_INIT_FAIL = 'MARINECARGOPARAM_INIT_FAIL'

// Manage Commission Voucher
export const COMVOUCHER_INIT_LOADING = 'COMVOUCHER_INIT_LOADING'
export const COMVOUCHER_INIT_SUCCESS = 'COMVOUCHER_INIT_SUCCESS'
export const COMVOUCHER_INIT_FAIL = 'COMVOUCHER_INIT_FAIL'

// My Revenue Sales Chart - AR: 2-Apr-2020
export const MYREVENUESALESCHART_INIT_LOADING = 'MYREVENUESALESCHART_INIT_LOADING'
export const MYREVENUESALESCHART_INIT_SUCCESS = 'MYREVENUESALESCHART_INIT_SUCCESS'
export const MYREVENUESALESCHART_INIT_FAIL = 'MYREVENUESALESCHART_INIT_FAIL'

// My Claims Status Summary - AR: 4-Apr-2020
export const MYCLAIMSSUMMARYCHART_INIT_LOADING = 'MYCLAIMSSUMMARYCHART_INIT_LOADING'
export const MYCLAIMSSUMMARYCHART_INIT_SUCCESS = 'MYCLAIMSSUMMARYCHART_INIT_SUCCESS'
export const MYCLAIMSSUMMARYCHART_INIT_FAIL = 'MYCLAIMSSUMMARYCHART_INIT_FAIL'

// ACCOUNT SPECIAL FUNCTION
export const SPECFUNCACCT_INIT_LOADING = 'SPECFUNCACCT_INIT_LOADING'
export const SPECFUNCACCT_INIT_SUCCESS = 'SPECFUNCACCT_INIT_SUCCESS'
export const SPECFUNCACCT_INIT_FAIL = 'SPECFUNCACCT_INIT_FAIL'

// Claim Release
export const CLMREL_INIT_LOADING = 'CLMREL_INIT_LOADING'
export const CLMREL_INIT_SUCCESS = 'CLMREL_INIT_SUCCESS'
export const CLMREL_INIT_FAIL = 'CLMREL_INIT_FAIL'
export const CLMREL_SEL_DATA = 'CLMREL_SEL_DATA'
export const CLMREL_LOAD_DATA = 'CLMREL_LOAD_DATA'

// Void Account Transaction
export const VOID_ACCOUNT_TRANSACTION_INIT_LOADING = 'VOID_ACCOUNT_TRANSACTION_INIT_LOADING'
export const VOID_ACCOUNT_TRANSACTION_INIT_SUCCESS = 'VOID_ACCOUNT_TRANSACTION_INIT_SUCCESS'
export const VOID_ACCOUNT_TRANSACTION_INIT_FAIL = 'VOID_ACCOUNT_TRANSACTION_INIT_FAIL'

// XOL Recovery
export const XOL_RECOVERY_INIT_LOADING = 'XOL_RECOVERY_INIT_LOADING'
export const XOL_RECOVERY_INIT_SUCCESS = 'XOL_RECOVERY_INIT_SUCCESS'
export const XOL_RECOVERY_INIT_FAIL = 'XOL_RECOVERY_INIT_FAIL'
export const XOL_RECOVERY_SELECT = 'XOL_RECOVERY_SELECT'

// OS Claim Reserve
export const OS_CLM_RES_INIT_LOADING = 'OS_CLM_RES_INIT_LOADING'
export const OS_CLM_RES_INIT_SUCCESS = 'OS_CLM_RES_INIT_SUCCESS'
export const OS_CLM_RES_INIT_FAIL = 'OS_CLM_RES_INIT_FAIL'

// Unset Claims Document Print Flag
export const UNSET_CLM_DOC_PRTFLAG_INIT_LOADING = 'UNSET_CLM_DOC_PRTFLAG_INIT_LOADING'
export const UNSET_CLM_DOC_PRTFLAG_INIT_SUCCESS = 'UNSET_CLM_DOC_PRTFLAG_INIT_SUCCESS'
export const UNSET_CLM_DOC_PRTFLAG_INIT_FAIL = 'UNSET_CLM_DOC_PRTFLAG_INIT_FAIL'

// Claims RI Recoveries
export const CLAIMS_RI_RECOVERIES_INIT_LOADING = 'CLAIMS_RI_RECOVERIES_INIT_LOADING'
export const CLAIMS_RI_RECOVERIES_INIT_SUCCESS = 'CLAIMS_RI_RECOVERIES_INIT_SUCCESS'
export const CLAIMS_RI_RECOVERIES_INIT_FAIL = 'CLAIMS_RI_RECOVERIES_INIT_FAIL'

// Industry Group
export const INDUSTRY_GRP_INIT_LOADING = 'INDUSTRY_GRP_INIT_LOADING'
export const INDUSTRY_GRP_INIT_SUCCESS = 'INDUSTRY_GRP_INIT_SUCCESS'
export const INDUSTRY_GRP_INIT_FAIL = 'INDUSTRY_GRP_INIT_FAIL'

// Customer Log
export const CUSTLOG_INIT_LOADING = 'CUSTLOG_INIT_LOADING'
export const CUSTLOG_INIT_SUCCESS = 'CUSTLOG_INIT_SUCCESS'
export const CUSTLOG_INIT_FAIL = 'CUSTLOG_INIT_FAIL'

// Customer Log Type
export const CUSTLOGTYPE_INIT_LOADING = 'CUSTLOGTYPE_INIT_LOADING'
export const CUSTLOGTYPE_INIT_SUCCESS = 'CUSTLOGTYPE_INIT_SUCCESS'
export const CUSTLOGTYPE_INIT_FAIL = 'CUSTLOGTYPE_INIT_FAIL'
export const CUSTLOGTYPE_COMMIT_KEY = 'CUSTLOGTYPE_COMMIT_KEY'

// Bonus Incentive Scheme
export const BOINCENSCH_INIT_LOADING = 'BOINCENSCH_INIT_LOADING'
export const BOINCENSCH_INIT_SUCCESS = 'BOINCENSCH_INIT_SUCCESS'
export const BOINCENSCH_INIT_FAIL = 'BOINCENSCH_INIT_FAIL'
export const BOINCENSCHEME_INIT_LOADING = 'BOINCENSCHEME_INIT_LOADING'
export const BOINCENSCHEME_INIT_SUCCESS = 'BOINCENSCHEME_INIT_SUCCESS'
export const BOINCENSCHEME_INIT_FAIL = 'BOINCENSCHEME_INIT_FAIL'
export const SECTOR_INIT_LOADING = 'SECTOR_INIT_LOADING'
export const SECTOR_INIT_SUCCESS = 'SECTOR_INIT_SUCCESS'
export const SECTOR_INIT_FAIL = 'SECTOR_INIT_FAIL'
export const ARM_INIT_LOADING = 'ARM_INIT_LOADING'
export const ARM_INIT_SUCCESS = 'ARM_INIT_SUCCESS'
export const ARM_INIT_FAIL = 'ARM_INIT_FAIL'
export const DIVISION_INIT_LOADING = 'DIVISION_INIT_LOADING'
export const DIVISION_INIT_SUCCESS = 'DIVISION_INIT_SUCCESS'
export const DIVISION_INIT_FAIL = 'DIVISION_INIT_FAIL'
export const DIVISION_COMMIT_KEY = 'DIVISION_COMMIT_KEY'
export const TEAM_INIT_LOADING = 'TEAM_INIT_LOADING'
export const TEAM_INIT_SUCCESS = 'TEAM_INIT_SUCCESS'
export const TEAM_INIT_FAIL = 'TEAM_INIT_FAIL'
export const TEAM_COMMIT_KEY = 'TEAM_COMMIT_KEY'

// Risk Area
export const RISKAREA_INIT_LOADING = 'RISKAREA_INIT_LOADING'
export const RISKAREA_INIT_SUCCESS = 'RISKAREA_INIT_SUCCESS'
export const RISKAREA_INIT_FAIL = 'RISKAREA_INIT_FAIL'

// Process Notification Parameters
export const PROCNOTIF_INIT_LOADING = 'PROCNOTIF_INIT_LOADING'
export const PROCNOTIF_INIT_SUCCESS = 'PROCNOTIF_INIT_SUCCESS'
export const PROCNOTIF_INIT_FAIL = 'PROCNOTIF_INIT_FAIL'

// Statement Type
export const STMTTYPE_INIT_LOADING = 'STMTTYPE_INIT_LOADING'
export const STMTTYPE_INIT_SUCCESS = 'STMTTYPE_INIT_SUCCESS'
export const STMTTYPE_INIT_FAIL = 'STMTTYPE_INIT_FAIL'

// Business Analysis
export const BUSANALYSIS_INIT_LOADING = 'BUSANALYSIS_INIT_LOADING'
export const BUSANALYSIS_INIT_SUCCESS = 'BUSANALYSIS_INIT_SUCCESS'
export const BUSANALYSIS_INIT_FAIL = 'BUSANALYSIS_INIT_FAIL'

// Retention Type
export const RTNTYPE_INIT_LOADING = 'RTNTYPE_INIT_LOADING'
export const RTNTYPE_INIT_SUCCESS = 'RTNTYPE_INIT_SUCCESS'
export const RTNTYPE_INIT_FAIL = 'RTNTYPE_INIT_FAIL'

// GL Transaction
export const GLTRAN_INIT_LOADING = 'GLTRAN_INIT_LOADING'
export const GLTRAN_INIT_SUCCESS = 'GLTRAN_INIT_SUCCESS'
export const GLTRAN_INIT_FAIL = 'GLTRAN_INIT_FAIL'

// UOB Proposal Status
export const PROPSTAT_INIT_LOADING = 'PROPSTAT_INIT_LOADING'
export const PROPSTAT_INIT_SUCCESS = 'PROPSTAT_INIT_SUCCESS'
export const PROPSTAT_INIT_FAIL = 'PROPSTAT_INIT_FAIL'
export const PROPSTAT_COMMIT_KEY = 'PROPSTAT_COMMIT_KEY'

// UOB Proposal Plan
export const PROPPLAN_INIT_LOADING = 'PROPPLAN_INIT_LOADING'
export const PROPPLAN_INIT_SUCCESS = 'PROPPLAN_INIT_SUCCESS'
export const PROPPLAN_INIT_FAIL = 'PROPPLAN_INIT_FAIL'

// Line Calculation
export const LNCALC_INIT_LOADING = 'LNCALC_INIT_LOADING'
export const LNCALC_INIT_SUCCESS = 'LNCALC_INIT_SUCCESS'
export const LNCALC_INIT_FAIL = 'LNCALC_INIT_FAIL'

// Calculation Rate
export const CALCRATE_INIT_LOADING = 'CALCRATE_INIT_LOADING'
export const CALCRATE_INIT_SUCCESS = 'CALCRATE_INIT_SUCCESS'
export const CALCRATE_INIT_FAIL = 'CALCRATE_INIT_FAIL'

// Default Standard Risk Text
export const DEF_STD_RISK_TXT_INIT_LOADING = 'DEF_STD_RISK_TXT_INIT_LOADING'
export const DEF_STD_RISK_TXT_INIT_SUCCESS = 'DEF_STD_RISK_TXT_INIT_SUCCESS'
export const DEF_STD_RISK_TXT_INIT_FAIL = 'DEF_STD_RISK_TXT_INIT_FAIL'

// Proposals
export const PROPOSAL_INIT_LOADING = 'PROPOSAL_INIT_LOADING'
export const PROPOSAL_INIT_SUCCESS = 'PROPOSAL_INIT_SUCCESS'
export const PROPOSAL_INIT_FAIL = 'PROPOSAL_INIT_FAIL'
export const PROPOSAL_LISTING_LOADING = 'PROPOSAL_LISTING_LOADING'
export const PROPOSAL_LISTING_SUCCESS = 'PROPOSAL_LISTING_SUCCESS'
export const PROPOSAL_LISTING_FAIL = 'PROPOSAL_LISTING_FAIL'
export const PROPOSAL_DETAILS_INIT_LOADING = 'PROPOSAL_DETAILS_INIT_LOADING'
export const PROPOSAL_DETAILS_INIT_SUCCESS = 'PROPOSAL_DETAILS_INIT_SUCCESS'
export const PROPOSAL_DETAILS_INIT_FAIL = 'PROPOSAL_DETAILS_INIT_FAIL'
export const PROPOSAL_DETAILS_LOAD_DATA = 'PROPOSAL_DETAILS_LOAD_DATA'
export const PROP_COVER_DET_INIT_LOADING = 'PROP_COVER_DET_INIT_LOADING'
export const PROP_COVER_DET_INIT_SUCCESS = 'PROP_COVER_DET_INIT_SUCCESS'
export const PROP_COVER_DET_INIT_FAIL = 'PROP_COVER_DET_INIT_FAIL'
export const PROPOSAL_REVIEW_MODE = 'PROPOSAL_REVIEW_MODE'
export const PROPOSAL_QUERY_MODE = 'PROPOSAL_QUERY_MODE'
export const PROPOSAL_CONVERT_MODE = 'PROPOSAL_CONVERT_MODE'

// Treaty Accounting
export const TTY_ACCT_INIT_LOADING = 'TTY_ACCT_INIT_LOADING'
export const TTY_ACCT_INIT_SUCCESS = 'TTY_ACCT_INIT_SUCCESS'
export const TTY_ACCT_INIT_FAIL = 'TTY_ACCT_INIT_FAIL'
export const TTY_MASTER_INIT_LOADING = 'TTY_MASTER_INIT_LOADING'
export const TTY_MASTER_INIT_SUCCESS = 'TTY_MASTER_INIT_SUCCESS'
export const TTY_MASTER_INIT_FAIL = 'TTY_MASTER_INIT_FAIL'
export const SPECFUNC_TTY_ACCT_INIT_LOADING = 'SPECFUNC_TTY_ACCT_INIT_LOADING'
export const SPECFUNC_TTY_ACCT_INIT_SUCCESS = 'SPECFUNC_TTY_ACCT_INIT_SUCCESS'
export const SPECFUNC_TTY_ACCT_INIT_FAIL = 'SPECFUNC_TTY_ACCT_INIT_FAIL'
export const UPLOAD_TTY_PREM_COMM_INIT_LOADING = 'UPLOAD_TTY_PREM_COMM_INIT_LOADING'
export const UPLOAD_TTY_PREM_COMM_INIT_SUCCESS = 'UPLOAD_TTY_PREM_COMM_INIT_SUCCESS'
export const UPLOAD_TTY_PREM_COMM_INIT_FAIL = 'UPLOAD_TTY_PREM_COMM_INIT_FAIL'
export const UPLOAD_TTY_CLM_PAYM_RES_INIT_LOADING = 'UPLOAD_TTY_CLM_PAYM_RES_INIT_LOADING'
export const UPLOAD_TTY_CLM_PAYM_RES_INIT_SUCCESS = 'UPLOAD_TTY_CLM_PAYM_RES_INIT_SUCCESS'
export const UPLOAD_TTY_CLM_PAYM_RES_INIT_FAIL = 'UPLOAD_TTY_CLM_PAYM_RES_INIT_FAIL'
export const GEN_QUART_STMT_INIT_LOADING = 'GEN_QUART_STMT_INIT_LOADING'
export const GEN_QUART_STMT_INIT_SUCCESS = 'GEN_QUART_STMT_INIT_SUCCESS'
export const GEN_QUART_STMT_INIT_FAIL = 'GEN_QUART_STMT_INIT_FAIL'
export const BATCH_RELEASE_MTHLY_TTY_STMT_INIT_LOADING = 'BATCH_RELEASE_MTHLY_TTY_STMT_INIT_LOADING'
export const BATCH_RELEASE_MTHLY_TTY_STMT_INIT_SUCCESS = 'BATCH_RELEASE_MTHLY_TTY_STMT_INIT_SUCCESS'
export const BATCH_RELEASE_MTHLY_TTY_STMT_INIT_FAIL = 'BATCH_RELEASE_MTHLY_TTY_STMT_INIT_FAIL'
export const BATCH_RELEASE_QRTLY_TTY_STMT_INIT_LOADING = 'BATCH_RELEASE_QRTLY_TTY_STMT_INIT_LOADING'
export const BATCH_RELEASE_QRTLY_TTY_STMT_INIT_SUCCESS = 'BATCH_RELEASE_QRTLY_TTY_STMT_INIT_SUCCESS'
export const BATCH_RELEASE_QRTLY_TTY_STMT_INIT_FAIL = 'BATCH_RELEASE_QRTLY_TTY_STMT_INIT_FAIL'

// Client Type Parameter
export const CLIENTTYPE_INIT_LOADING = 'CLIENTTYPE_INIT_LOADING'
export const CLIENTTYPE_INIT_SUCCESS = 'CLIENTTYPE_INIT_SUCCESS'
export const CLIENTTYPE_INIT_FAIL = 'CLIENTTYPE_INIT_FAIL'

// Executive In Charge Parameter
export const EXECINCHARGE_INIT_LOADING = 'EXECINCHARGE_INIT_LOADING'
export const EXECINCHARGE_INIT_SUCCESS = 'EXECINCHARGE_INIT_SUCCESS'
export const EXECINCHARGE_INIT_FAIL = 'EXECINCHARGE_INIT_FAIL'

// Claims Limit per User Parameter
export const USRCLMLIM_INIT_LOADING = 'USRCLMLIM_INIT_LOADING'
export const USRCLMLIM_INIT_SUCCESS = 'USRCLMLIM_INIT_SUCCESS'
export const USRCLMLIM_INIT_FAIL = 'USRCLMLIM_INIT_FAIL'

// Common Comments
export const COMMON_COMMENTS_INIT_LOADING = 'COMMON_COMMENTS_INIT_LOADING'
export const COMMON_COMMENTS_INIT_SUCCESS = 'COMMON_COMMENTS_INIT_SUCCESS'
export const COMMON_COMMENTS_INIT_FAIL = 'COMMON_COMMENTS_INIT_FAIL'

// Risk Profiles
export const RISKPROF_INIT_LOADING = 'RISKPROF_INIT_LOADING'
export const RISKPROF_INIT_SUCCESS = 'RISKPROF_INIT_SUCCESS'
export const RISKPROF_INIT_FAIL = 'RISKPROF_INIT_FAIL'

// My Claims Notifications - AR: 26-Oct-2020
export const MYCLAIMSNOTIFICATIONS_INIT_LOADING = 'MYCLAIMSNOTIFICATIONS_INIT_LOADING'
export const MYCLAIMSNOTIFICATIONS_INIT_SUCCESS = 'MYCLAIMSNOTIFICATIONS_INIT_SUCCESS'
export const MYCLAIMSNOTIFICATIONS_INIT_FAIL = 'MYCLAIMSNOTIFICATIONS_INIT_FAIL'

// Delete Unreleased Claims
export const DEL_CLMUNREL_INIT_LOADING = 'DEL_CLMUNREL_INIT_LOADING'
export const DEL_CLMUNREL_INIT_SUCCESS = 'DEL_CLMUNREL_INIT_SUCCESS'
export const DEL_CLMUNREL_INIT_FAIL = 'DEL_CLMUNREL_INIT_FAIL'
export const DEL_CLMUNREL_SEL_DATA = 'DEL_CLMUNREL_SEL_DATA'

// Event Type
export const EVENT_TYPE_INIT_LOADING = 'EVENT_TYPE_INIT_LOADING'
export const EVENT_TYPE_INIT_SUCCESS = 'EVENT_TYPE_INIT_SUCCESS'
export const EVENT_TYPE_INIT_FAIL = 'EVENT_TYPE_INIT_FAIL'

// Search Filter
export const SEARCHFILTER_INIT_LOADING = 'SEARCHFILTER_INIT_LOADING'
export const SEARCHFILTER_INIT_SUCCESS = 'SEARCHFILTER_INIT_SUCCESS'
export const SEARCHFILTER_INIT_FAIL = 'SEARCHFILTER_INIT_FAIL'

// Voluntary Cession Limit
export const VOL_CES_LIM_INIT_LOADING = 'VOL_CES_LIM_INIT_LOADING'
export const VOL_CES_LIM_INIT_SUCCESS = 'VOL_CES_LIM_INIT_SUCCESS'
export const VOL_CES_LIM_INIT_FAIL = 'VOL_CES_LIM_INIT_FAIL'

// BATCH GL UPDATE
export const BATCHGLUPDATE_INIT_LOADING = 'BATCHGLUPDATE_INIT_LOADING'
export const BATCHGLUPDATE_INIT_SUCCESS = 'BATCHGLUPDATE_INIT_SUCCESS'
export const BATCHGLUPDATE_INIT_FAIL = 'BATCHGLUPDATE_INIT_FAIL'

// General Ledger
export const GENERAL_LEDGER_INIT_LOADING = 'GENERAL_LEDGER_INIT_LOADING'
export const GENERAL_LEDGER_INIT_SUCCESS = 'GENERAL_LEDGER_INIT_SUCCESS'
export const GENERAL_LEDGER_INIT_FAIL = 'GENERAL_LEDGER_INIT_FAIL'

// Start/Close Financial Year
export const FINANCIAL_YEAR_INIT_LOADING = 'FINANCIAL_YEAR_INIT_LOADING'
export const FINANCIAL_YEAR_INIT_SUCCESS = 'FINANCIAL_YEAR_INIT_SUCCESS'
export const FINANCIAL_YEAR_INIT_FAIL = 'FINANCIAL_YEAR_INIT_FAIL'

// Intermediary Type Parameter
export const INTER_TYPE_INIT_LOADING = 'INTER_TYPE_INIT_LOADING'
export const INTER_TYPE_INIT_SUCCESS = 'INTER_TYPE_INIT_SUCCESS'
export const INTER_TYPE_INIT_FAIL = 'INTER_TYPE_INIT_FAIL'

// Endorsement Code
export const ENDTCODE_INIT_LOADING = 'ENDTCODE_INIT_LOADING'
export const ENDTCODE_INIT_SUCCESS = 'ENDTCODE_INIT_SUCCESS'
export const ENDTCODE_INIT_FAIL = 'ENDTCODE_INIT_FAIL'

// Cancellation Code
export const CANCELCODE_INIT_LOADING = 'CANCELCODE_INIT_LOADING'
export const CANCELCODE_INIT_SUCCESS = 'CANCELCODE_INIT_SUCCESS'
export const CANCELCODE_INIT_FAIL = 'CANCELCODE_INIT_FAIL'

// Giro Bank BIC
export const GIROBANK_INIT_LOADING = 'GIROBANK_INIT_LOADING'
export const GIROBANK_INIT_SUCCESS = 'GIROBANK_INIT_SUCCESS'
export const GIROBANK_INIT_FAIL = 'GIROBANK_INIT_FAIL'

// Occupation
export const OCCUPATION_INIT_LOADING = 'OCCUPATION_INIT_LOADING'
export const OCCUPATION_INIT_SUCCESS = 'OCCUPATION_INIT_SUCCESS'
export const OCCUPATION_INIT_FAIL = 'OCCUPATION_INIT_FAIL'

// Relationship
export const RELATIONSHIP_INIT_LOADING = 'RELATIONSHIP_INIT_LOADING'
export const RELATIONSHIP_INIT_SUCCESS = 'RELATIONSHIP_INIT_SUCCESS'
export const RELATIONSHIP_INIT_FAIL = 'RELATIONSHIP_INIT_FAIL'

// ANNUAL RENEWAL BONUS
export const ARB_COMMIT_KEY = 'ARB_COMMIT_KEY'

// INSURED AGE BAND
export const IAB_COMMIT_KEY = 'IAB_COMMIT_KEY'

// No Claim Bonus (DMNCB)
export const DMNCBPARAM_INIT_LOADING = 'DMNCBPARAM_INIT_LOADING'
export const DMNCBPARAM_INIT_SUCCESS = 'DMNCBPARAM_INIT_SUCCESS'
export const DMNCBPARAM_INIT_FAIL = 'DMNCBPARAM_INIT_FAIL'

// Cover Letter
export const COVER_LETTER_INIT_LOADING = 'COVER_LETTER_INIT_LOADING'
export const COVER_LETTER_INIT_SUCCESS = 'COVER_LETTER_INIT_SUCCESS'
export const COVER_LETTER_INIT_FAIL = 'COVER_LETTER_INIT_FAIL'

// Cancellation Letter
export const CANCELLTR_INIT_LOADING = 'CANCELLTR_INIT_LOADING'
export const CANCELLTR_INIT_SUCCESS = 'CANCELLTR_INIT_SUCCESS'
export const CANCELLTR_INIT_FAIL = 'CANCELLTR_INIT_FAIL'

// Payment Status Letter
export const PAYTSTATLTR_INIT_LOADING = 'PAYTSTATLTR_INIT_LOADING'
export const PAYTSTATLTR_INIT_SUCCESS = 'PAYTSTATLTR_INIT_SUCCESS'
export const PAYTSTATLTR_INIT_FAIL = 'PAYTSTATLTR_INIT_FAIL'
export const PAYTSTATLTR_COMMIT_KEY = 'PAYTSTATLTR_COMMIT_KEY'

export const DISPATCH_SAVE = 'DISPATCH_SAVE'
export const DISPATCH_CLEAR = 'DISPATCH_CLEAR'

// Policy Type Group
export const POLTYPE_GRP_INIT_LOADING = 'POLTYPE_GRP_INIT_LOADING'
export const POLTYPE_GRP_INIT_SUCCESS = 'POLTYPE_GRP_INIT_SUCCESS'
export const POLTYPE_GRP_INIT_FAIL = 'POLTYPE_GRP_INIT_FAIL'

// Claim Renewal Messages
export const CLM_REN_MSG_INIT_LOADING = 'CLM_REN_MSG_INIT_LOADING'
export const CLM_REN_MSG_INIT_SUCCESS = 'CLM_REN_MSG_INIT_SUCCESS'
export const CLM_REN_MSG_INIT_FAIL = 'CLM_REN_MSG_INIT_FAIL'

// Post Exchange Differences
export const POST_EXCHANGE_DIFFERENCES_LOADING = 'POST_EXCHANGE_DIFFERENCES_LOADING'
export const POST_EXCHANGE_DIFFERENCES_SUCCESS = 'POST_EXCHANGE_DIFFERENCES_SUCCESS'
export const POST_EXCHANGE_DIFFERENCES_FAIL = 'POST_EXCHANGE_DIFFERENCES_FAIL'

// Write Off Small Balance
export const WRITE_OFF_SMALL_BALANCE_LOADING = 'WRITE_OFF_SMALL_BALANCE_LOADING'
export const WRITE_OFF_SMALL_BALANCE_SUCCESS = 'WRITE_OFF_SMALL_BALANCE_SUCCESS'
export const WRITE_OFF_SMALL_BALANCE_FAIL = 'WRITE_OFF_SMALL_BALANCE_FAIL'

// Director Relationship
export const DIRECTOR_RELATIONSHIP_LOADING = 'DIRECTOR_RELATIONSHIP_LOADING'
export const DIRECTOR_RELATIONSHIP_SUCCESS = 'DIRECTOR_RELATIONSHIP_SUCCESS'
export const DIRECTOR_RELATIONSHIP_FAIL = 'DIRECTOR_RELATIONSHIP_FAIL'

// Exclude GST Patching
export const EXCL_GST_PATCHING_LOADING = 'EXCL_GST_PATCHING_LOADING'
export const EXCL_GST_PATCHING_SUCCESS = 'EXCL_GST_PATCHING_SUCCESS'
export const EXCL_GST_PATCHING_FAIL = 'EXCL_GST_PATCHING_FAIL'

// GST-Rebilling
export const GST_REBILLING_LOADING = 'GST_REBILLING_LOADING'
export const GST_REBILLING_SUCCESS = 'GST_REBILLING_SUCCESS'
export const GST_REBILLING_FAIL = 'GST_REBILLING_FAIL'

// Download GL Transactions (SUNGL)
export const DOWNLOAD_GL_TRAN_LOADING = 'DOWNLOAD_GL_TRAN_LOADING'
export const DOWNLOAD_GL_TRAN_SUCCESS = 'DOWNLOAD_GL_TRAN_SUCCESS'
export const DOWNLOAD_GL_TRAN_FAIL = 'DOWNLOAD_GL_TRAN_FAIL'

// Termination Reason
export const TERM_REASON_INIT_LOADING = 'TERM_REASON_INIT_LOADING'
export const TERM_REASON_INIT_SUCCESS = 'TERM_REASON_INIT_SUCCESS'
export const TERM_REASON_INIT_FAIL = 'TERM_REASON_INIT_FAIL'

export const IFRS_DATA_EXTRACTION_LOADING = 'IFRS_DATA_EXTRACTION_LOADING'
export const IFRS_DATA_EXTRACTION_SUCCESS = 'IFRS_DATA_EXTRACTION_SUCCESS'
export const IFRS_DATA_EXTRACTION_FAIL = 'IFRS_DATA_EXTRACTION_FAIL'

// MATCHING
export const MATCHING_INIT_LOADING = 'MATCHING_INIT_LOADING'
export const MATCHING_INIT_SUCCESS = 'MATCHING_INIT_SUCCESS'
export const MATCHING_INIT_FAIL = 'MATCHING_INIT_FAIL'
export const BATCH_MATCH_TRANS_INIT_LOADING = 'BATCH_MATCH_TRANS_INIT_LOADING'
export const BATCH_MATCH_TRANS_INIT_SUCCESS = 'BATCH_MATCH_TRANS_INIT_SUCCESS'
export const BATCH_MATCH_TRANS_INIT_FAIL = 'BATCH_MATCH_TRANS_INIT_FAIL'
export const PERFORM_MATCH_INIT_LOADING = 'PERFORM_MATCH_INIT_LOADING'
export const PERFORM_MATCH_INIT_SUCCESS = 'PERFORM_MATCH_INIT_SUCCESS'
export const PERFORM_MATCH_INIT_FAIL = 'PERFORM_MATCH_INIT_FAIL'
export const INDIC_UNLOCK = 'INDIC_UNLOCK'

// Duration param
export const DURATION_PARAM_INIT_LOADING = 'DURATION_PARAM_INIT_LOADING'
export const DURATION_PARAM_INIT_SUCCESS = 'DURATION_PARAM_INIT_SUCCESS'
export const DURATION_PARAM_INIT_FAIL = 'DURATION_PARAM_INIT_FAIL'

export const DURATION_INIT_LOADING = 'DURATION_INIT_LOADING'
export const DURATION_INIT_SUCCESS = 'DURATION_INIT_SUCCESS'
export const DURATION_INIT_FAIL = 'DURATION_INIT_FAIL'

// Injured Person Type
export const INJURED_PERSON_TYPE_INIT_LOADING = 'INJURED_PERSON_TYPE_INIT_LOADING'
export const INJURED_PERSON_TYPE_INIT_SUCCESS = 'INJURED_PERSON_TYPE_INIT_SUCCESS'
export const INJURED_PERSON_TYPE_INIT_FAIL = 'INJURED_PERSON_TYPE_INIT_FAIL'

export const CHG_ACCT_MCH_UUID = 'CHG_ACCT_MCH_UUID'
export const CHG_ACCT_MCH_BASE = 'CHG_ACCT_MCH_BASE'
export const CHG_ACCT_MCH_SEL = 'CHG_ACCT_MCH_SEL'
export const CHG_ACCT_MCH_FILE = 'CHG_ACCT_MCH_FILE'
export const CHG_ACCT_MCH_RECKEY = 'CHG_ACCT_MCH_RECKEY'
export const CHG_ACCT_MCH_CANCEL = 'CHG_ACCT_MCH_CANCEL'
export const CHG_ACCT_MCH_ISUPLD = 'CHG_ACCT_MCH_ISUPLD'

export const BATCH_MANAGER_INIT_LOADING = 'BATCH_MANAGER_INIT_LOADING'
export const BATCH_MANAGER_INIT_SUCCESS = 'BATCH_MANAGER_INIT_SUCCESS'
export const BATCH_MANAGER_INIT_FAIL = 'BATCH_MANAGER_INIT_FAIL'

export const MSAL_LOADING = 'MSAL_LOADING'

export const GL_DEPT_INIT_SUCCESS = 'GL_DEPT_INIT_SUCCESS'
export const GL_DEPT_INIT_FAIL = 'GL_DEPT_INIT_FAIL'
export const GL_DEPT_INIT_LOADING = 'GL_DEPT_INIT_LOADING'
